// 根据域名判断当前所属的子站
window.Shopify.currency = {
  ...window.Shopify.currency,
  icon: '$',
  lengthUnit: '"',
  lengthRate: 1
};
if (window.Shopify.routes.root == '/') {
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '$',
    lengthUnit: '"',
    lengthRate: 1
  };
}
if (window.Shopify.routes.root.includes('uk')) {
  // 英国
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '￡',
    lengthUnit: 'cm',
    lengthRate: 2.54
  };
}
if (window.Shopify.routes.root.includes('de')) {
  // 德国
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '€',
    lengthUnit: 'cm',
    lengthRate: 2.54
  };
}
if (window.Shopify.routes.root.includes('fr')) {
  // 法国
  window.Shopify.currency = {
    ...window.Shopify.currency,
    lengthUnit: 'cm',
    lengthRate: 2.54
  };
}

// 获取数字部分
function matchNum(str = '') {
  const s = str.toString();

  // 优先匹配百分比数字（后面紧跟 %）
  const percentMatch = s.match(/(\d+\.?\d*|\.\d+)\s*%/);
  if (percentMatch) {
    return parseFloat(percentMatch[1]) || 0;
  }

  // 没有百分比时，再匹配普通数字
  const normalMatch = s.match(/\d+\.?\d*|\.\d+/);
  if (normalMatch) {
    return parseFloat(normalMatch[0]) || 0;
  }

  return 0;
}

// 判断是否是IOS设备
function getIOSType() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/iphone/.test(userAgent)) return "iPhone";
  if (/ipad/.test(userAgent)) return "iPad";
  if (/ipod/.test(userAgent)) return "iPod";
  return false; // 非iOS设备
}

// 尺寸测量示意图及文案
function measurementMsgChange(header, coll) {
  const isPleated = ['French Pinch Pleat', 'Inverted Box Pleat', 'Goblet', 'Euro Pleat'];
  var tipType = false;
  var tipText = [];

  const params = {
    isDoor: false,
    isCurtain: false,
    isSoundproof: false,
    isSheer: false,
    [`is${coll}`]: true
  };

  tipText.push(`<p>Panel Width = Desired Curtain Coverage Width * <a href="/pages/curtain-measurement" target="_blank">Fullness Ratio</a> / Panel Quantity</p>`);
  tipText.push(`According to your chosen header type (${header}), we recommend a fullness ratio of `);
  if (header.includes('Grommet Top')) {
    tipText.push(`1.5x.`);
    tipType = true;
  }
  if (header.includes('Rod Pocket')) {
    if (params.isSoundproof) {
      // 是否隔音
      tipText.push(`1.2x.`);
    } else if (params.isSheer) {
      // 是否为纱
      tipText.push(`1.8x to 2x.`);
    } else {
      tipText.push(`1.5x.`);
    }
    tipType = true;
  }
  const isPleatedType = isPleated.filter(item => {
    return header.includes(item);
  }).length > 0;
  if (isPleatedType) {
    tipText.push(`1.1x.<br />We suggest selecting the finished width at a 1.1x ratio, as the curtain already includes 2.0-2.3x fullness sewn into the pleats.`);
    tipType = true;
  }
  if (header.includes('Pleat Hook')) {
    tipText.push(`1.5x to 1.8x.`);
    tipType = true;
  }
  // 特定产品(8780116951290) Tab Top 推荐 fullness 改为 1.8x-2x
  if (header === 'Tab Top' && product.id == 8780116951290) {
    tipText = [`<p>According to your chosen header type (${header}), we recommend a fullness ratio of 1.8x to 2x.</p>`];
    tipType = true;
  }
  // 蛇形帘提示使用 size guide 计算
  if (header.includes('Ripple Fold with Tape Buckle')) {
    tipText = [`<p>Check the Size Guide on the right to calculate the Single Panel Width you need to order.</p>`];
    tipType = true;
  }

  if (!tipType) {
    tipText = [`<p>Panel Width = Desired Curtain Coverage Width * <a href="/pages/curtain-measurement" target="_blank">Fullness Ratio</a> / Panel Quantity</p>`];
  }

  if (params.isDoor) {
    tipText = [];
  }

  return tipText.join('');
}

// 尺寸测量示意图及文案
function measurementMsgChange1(header, coll) {
  const isPleated = ['French Pinch Pleat', 'Inverted Box Pleat', 'Goblet', 'Euro Pleat'];
  var tipType = false, isDoor = false, isCurtain = false, isSoundproof = false, isSheer = false;
  var tipText = [];

  switch (coll) {
    case 'Door':
      isDoor = true;
      break;
    case 'Curtain':
      isCurtain = true;
      break;
    case 'Soundproof':
      isSoundproof = true;
      break;
    case 'Sheer':
      isSheer = true;
      break;
    default:
      break;
  }

  // this[`is${coll}`] = true;

  if (header != undefined) {
    tipText.push(`Recommended fullness for ${header} header is `);
    if (header == 'Grommet Top' || header.toUpperCase() == 'GROMMET TOP — SILVER RINGS' || header.toUpperCase() == 'GROMMET TOP — SILVER RING' || header.toUpperCase() == 'GROMMET TOP - SILVER RING') {
      tipText.push(`1.5x.`);
      tipType = true;
    }
    if (header == 'Grommet Top Bottom' || header.toUpperCase() == 'GROMMET TOP BOTTOM - SILVER RING') {
      tipText.push(`1.5x.`);
      tipType = true;
    }
    if (header == 'Velcro Tab Top' || header == 'Tab Top') {
      // 特定产品(8780116951290) Tab Top 推荐 fullness 改为 1.8x-2x
      if (header === 'Tab Top' && product.id == 8780116951290) {
        tipText.push(`1.8x to 2x.`);
      } else {
        tipText.push(`1.2x.`);
      }
      tipType = true;
    }
    if (header.includes('Rod Pocket')) {
      if (isSoundproof) {
        // 是否隔音
        tipText.push(`1.2x.`);
      } else if (isSheer) {
        // 是否为纱
        tipText.push(`1.8x to 2x.`);
      } else {
        tipText.push(`1.5x.`);
      }
      tipType = true;
    }
    const isPleatedType = isPleated.filter(item => {
      return header.includes(item);
    }).length > 0;
    if (isPleatedType) {
      tipText.push(`1.1x.`);
      tipType = true;
    }
    if (header.includes('Pleat Hook')) {
      if (isSheer) {
        tipText.push(`2x.`);
      } else if (isCurtain) {
        tipText.push(`1.8x.`);
      } else if (isSoundproof) {
        tipText.push(`1.6x.`);
      } else {
        tipText.push(`1.5x.`);
      }
      tipType = true;
    }
    // 蛇形帘提示使用 size guide 计算
    if (header.includes('Ripple Fold with Tape Buckle')) {
      tipText = [`<p>Check the Size Guide on the right to calculate the Single Panel Width you need to order.</p>`];
      tipType = true;
    }
  }

  if (!tipType) {
    tipText = [`<p>Panel Width = Desired Curtain Coverage Width * <a href="/pages/curtain-measurement" target="_blank">Fullness Ratio</a> / Panel Quantity</p>`];
  }

  if (isDoor) {
    tipText = [];
  }

  return tipText.join('');
}

// 删除数组中指定内容
function arrDel(arr, name) {
  const index = arr.indexOf(name);
  if (index !== -1) {
    arr.splice(index, 1);
  }
}

// 替换实体函数
function decodeHtmlEntities(str) {
  const htmlEntities = {
    '&#39;': "'",
    '&quot;': '"',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>'
  };
  return str.replace(/&#?\w+;/g, match =>
    htmlEntities[match] || match // 优先使用映射，未匹配则保留原样
  );
}

const minSpend = Number(document.querySelector(".cart-shipping")?.dataset.minSpend || 0);
const minTotal = Math.round(minSpend * (Shopify.currency.rate || 1));

// ── 购物车奖励阶梯 ──────────────────────────────────────────────────────────
// 只显示「下一个还没拿到的奖励」，已拿到的收成一行对勾。
// 为什么不并排两条进度条：免运费门槛 $90，88.5% 的订单一进车就过了，那条永远
// 是「已达成」，占位置还把注意力从满减上引开。
//
// 口径（2026-10-09 实测后重写，三处都踩过坑）：
//  1. 基数用 cartData.rewards_base（cartDataInit 算的，含定制属性加价），不是
//     cart.items_subtotal_price —— 后者只认 variant 价，和真正收钱的草稿单差很远。
//     Hussein 两件原生 $241.40、草稿单报价 $875.50，用错数会告诉顾客"还差 $358"
//     而结账时其实早就达标。
//  2. 金额一律是 presentment 货币（/cart.js 合约如此），只把**门槛**从店铺货币
//     换算一次。以前两边都乘了 rate，GBP 下凭空多出一截差额。
//  3. 不断言「已应用」。满减能不能落地由 Shopify 在结账时按 combinesWith、
//     客户资格、礼品卡双门槛判定，前端猜不准也不该猜 —— 车里一旦已有订单级
//     折扣（ORDER 类，实测 orderDiscounts=false 不可叠加），整块不显示。
// 折扣标题进 innerHTML 前转义。标题来自后台（运营可填），不是顾客输入，
// 但拼 HTML 就该转义 —— 一个 & 或 < 就能把这行渲染坏。
// 折扣摘要超过这么多行就收起来。活动叠加多的时候（商品折扣 + 满减 + 订单码）
// 这一块会把结算按钮挤下去。
const DISCOUNT_COLLAPSE_AFTER = 3;

// ⚠ 和 component-discounts.css 的 .discounts--collapsed .discounts__discount:nth-child(n + 4)
//   是一对，改阈值要两边一起改。
function applyDiscountCollapse() {
  document.querySelectorAll("ul.discounts").forEach(function (ul) {
    var host = ul.parentNode;
    var old = host && host.querySelector(".discounts__toggle");
    if (old) old.remove();
    ul.classList.remove("discounts--collapsed");

    var rows = ul.querySelectorAll(".discounts__discount");
    if (rows.length <= DISCOUNT_COLLAPSE_AFTER || !host) return;

    if (!ul.id) ul.id = "discounts-" + Math.random().toString(36).slice(2, 9);
    ul.classList.add("discounts--collapsed");

    var hidden = rows.length - DISCOUNT_COLLAPSE_AFTER;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "discounts__toggle";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", ul.id);
    btn.textContent = "Show " + hidden + " more";
    btn.addEventListener("click", function () {
      var collapsed = ul.classList.toggle("discounts--collapsed");
      btn.setAttribute("aria-expanded", collapsed ? "false" : "true");
      btn.textContent = collapsed ? "Show " + hidden + " more" : "Show less";
    });
    ul.after(btn);
  });
}

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function cartRewardsConfig() {
  const el = document.querySelector(".cart-rewards");
  if (!el) return null;
  const d = el.dataset;
  // data-* 里给的是**店铺货币的分**；换算成 presentment 再和 cart 金额比。
  const rate = window.Shopify?.currency?.rate || 1;
  const toPresentment = v => Math.round(Number(v || 0) * rate);
  return {
    showShipping: d.showShipping === "true",
    showReward: d.showReward === "true",
    shipMin: toPresentment(d.minSpend),
    rewardMin: toPresentment(d.rewardMin),
    rewardAmount: toPresentment(d.rewardAmount),
    msgShip: d.message || "",
    msgReward: d.messageReward || "",
    msgRewardHint: d.messageRewardHint || "",
    msgRewardSuccess: d.messageRewardSuccess || "",
    labelShipping: d.labelShipping || "",
    labelSpendRow: d.labelSpendRow || "",
    // 不能和满减叠加的折扣标题（后台 combinesWith.orderDiscounts=false 的那些）。
    // 做成设置而不是写死在 JS 里：换活动时标题会变，运营能自己改。
    excludedTitles: (d.rewardExcludedDiscounts || "")
      .split(",").map(x => x.trim().toLowerCase()).filter(Boolean),
  };
}

// 基数：cartDataInit 算好的 rewards_base。取不到就认为不可信，整块不显示，
// 而不是退回 items_subtotal_price —— 那个数对定制窗帘是错的。
function cartRewardsBase(cartData) {
  return typeof cartData?.rewards_base === "number" ? cartData.rewards_base : null;
}

// 显示金额：cart 金额已经是 presentment，不再乘 rate。
function cartRewardsMoney(cents) {
  const icon = window.Shopify?.currency?.icon || "$";
  return `${icon}${Math.abs(cents / 100).toFixed(2)}`;
}

// 车里已有订单级折扣 → 满减不可叠加（实测 CM20/TRADE 等 ORDER 类规则
// combinesWith.orderDiscounts=false）。读 Shopify 原生字段，不按行级比率判：
// cartDataInit 会改写 original_line_price，按比率会把定制加价误判成折扣。
function cartRewardsHasOrderDiscount(cartData) {
  const apps = (cartData && cartData.cart_level_discount_applications) || [];
  return apps.length > 0;
}

// 车里有没有「不能和满减叠加」的商品折扣。按标题匹配后台 combinesWith 的配置：
// 40%/25% 档 orderDiscounts=false，15%/10% 档 true。不判的话会出现「40% 折后
// $300，还劝顾客 Add $300 to save $50」—— 那 $50 永远兑不出来。
function cartRewardsHasBlockingProductDiscount(cartData, titles) {
  if (!titles || !titles.length) return false;
  const items = (cartData && cartData.items) || [];
  return items.some(it => (it.discounts || []).some(
    d => titles.includes(String(d.title || "").trim().toLowerCase())));
}

// 满减资格：奖励条和 Total 共用这一个判定，两处不能再各算各的。
// 以前条说「$50 已解锁」而 Total 里没有这 $50 —— 因为 Shopify 原生购物车按 variant
// 价判 $600 门槛（这单原生只有 $241.40），而真正收钱的草稿单按含定制加价的 $1,030 判，
// 会应用。主题本来就在覆盖原生算术（Subtotal 显示 $1,030 而不是 $241.40），
// Total 也该跟着草稿单走（2026-10-09 实测草稿单 #D15743 / 报价 $825.50）。
//
// 任何说不准的情况一律判不合格，宁可少显示，不能购物车承诺而结账给不了。
function cartSpendRewardState(cartData) {
  const none = { eligible: false, amount: 0, label: '' };
  const cfg = cartRewardsConfig();
  if (!cfg || !cfg.showReward || cfg.rewardMin <= 0 || cfg.rewardAmount <= 0) return none;

  const pre = cartData && cartData.rewards_base_pre;
  const post = cartData && cartData.rewards_base_post;
  if (!Number.isFinite(pre) || !Number.isFinite(post)) return none;

  // 已有订单级折扣，或车里有标注了不可叠加的商品折扣 → 满减叠不上
  if (cartRewardsHasOrderDiscount(cartData)) return none;
  if (cartRewardsHasBlockingProductDiscount(cartData, cfg.excludedTitles)) return none;

  // Shopify 官方两道门槛：① 折前排除购卡 ② 折后含购卡
  if (pre < cfg.rewardMin || post < cfg.rewardMin) return none;

  return { eligible: true, amount: cfg.rewardAmount, label: cfg.labelSpendRow || '' };
}

function updateCartRewards(cartData, hasValidTotals) {
  const root = document.querySelector(".cart-rewards");
  if (!root) return;
  const cfg = cartRewardsConfig();

  const bar = root.querySelector(".cart-rewards__bar");
  const fill = root.querySelector(".cart-rewards__bar-fill");
  const msg = root.querySelector(".cart-rewards__message");
  const hint = root.querySelector(".cart-rewards__hint");
  const earned = root.querySelector(".cart-rewards__earned");
  const earnedShip = root.querySelector('[data-reward="shipping"]');
  const earnedSpend = root.querySelector('[data-reward="spend"]');
  const hide = el => el && el.setAttribute("hidden", "");
  const show = el => el && el.removeAttribute("hidden");

  [bar, msg, hint, earned, earnedShip, earnedSpend].forEach(hide);

  if (!hasValidTotals || !cfg) return;
  const basePost = cartRewardsBase(cartData);
  if (basePost === null || basePost <= 0) return;
  const basePre = typeof cartData.rewards_base_pre === "number"
    ? cartData.rewards_base_pre : basePost;

  // 满减能不能兑现：已有订单级折扣、或车里有不可叠加的商品折扣，就都不行。
  // **只禁满减这一档** —— 以前整个 return，把已经达成的免运费也一起藏了
  // （$1000 车用 CM20 后免运费状态凭空消失）。免运费和满减是两件事。
  // 和 Total 共用同一个判定函数，避免两处口径漂移
  const spendBlocked =
    cartRewardsHasOrderDiscount(cartData) ||
    cartRewardsHasBlockingProductDiscount(cartData, cfg.excludedTitles);

  const setEarned = (node, text) => {
    if (!node || !text) return;
    node.querySelector(".cart-rewards__earned-text").textContent = text;
    show(node);
    show(earned);
  };

  // 门槛按金额从小到大排，不假设免运费一定比满减低 —— 后台两个数都能随便填。
  // gap = 还差多少。满减要过两道门槛，取差得更多的那道。
  const tiers = [];
  if (cfg.showShipping && cfg.shipMin > 0) {
    tiers.push({ min: cfg.shipMin, gap: Math.max(0, cfg.shipMin - basePost),
                 node: earnedShip, earnedText: cfg.labelShipping,
                 template: cfg.msgShip, hint: "", progress: basePost / cfg.shipMin });
  }
  if (cfg.showReward && !spendBlocked && cfg.rewardMin > 0 && cfg.rewardAmount > 0) {
    const gap = Math.max(cfg.rewardMin - basePre, cfg.rewardMin - basePost, 0);
    tiers.push({ min: cfg.rewardMin, gap,
                 node: earnedSpend,
                 earnedText: cfg.msgRewardSuccess.replace("||reward||", cartRewardsMoney(cfg.rewardAmount)),
                 template: cfg.msgReward, hint: cfg.msgRewardHint,
                 progress: Math.min(basePre, basePost) / cfg.rewardMin });
  }
  tiers.sort((a, b) => a.min - b.min);

  let next = null;
  for (const t of tiers) {
    if (t.gap <= 0) setEarned(t.node, t.earnedText);
    else if (!next) next = t;
  }
  if (!next) return;

  msg.textContent = next.template
    .replace("||amount||", cartRewardsMoney(next.gap))
    .replace("||reward||", cartRewardsMoney(cfg.rewardAmount))
    .trim();
  show(msg);
  if (next.hint) {
    hint.textContent = next.hint;
    show(hint);
  }
  if (fill) {
    fill.style.width = `${Math.min(100, Math.round(next.progress * 100))}%`;
    show(bar);
  }
}
// ────────────────────────────────────────────────────────────────────────────
// 购物车价格初始化
// 属性加价的解析只有一份：cart-flow.js 的 CartFlow.propertyCents（含负价，如 "22\" | $-1"）。
// 购物车编辑器、优惠框也用它；这里只是转调，别在这里另写正则。
function cartPropertyCents(value) {
  return CartFlow.propertyCents(value);
}

// Xcotton 运费保障商品（handle shipping-protection）：客户点结账时 Xcotton 才加进车、从结账页返回时会短暂留着。
// 它的钱由保障卡片展示、结算按钮计入；主题的小计/总计再算一遍就是重复（2026-09-24 评审）。
// Liquid 那边同样跳过它（cart-drawer.liquid / main-cart-items.liquid）。
function isShippingProtectionLine(item) {
  return String(item && item.handle || '') === 'shipping-protection';
}

// 购物车指纹：给满减绑定「这是哪辆车算出来的」。
// 只取 key×quantity —— cartDataInit 会改写 original_line_price 等字段，拿金额做指纹
// 会自己把自己判失配。排除 Xcotton 的运费保障行：它在点结算时才被加进车，
// 不该让奖励失效。
// ⚠ layout/theme.liquid 的 wrapper 有一份**逐字一致**的实现（它在 utils.js 之前
//   同步执行，没法复用这里的函数）。改这里务必同步改那边。
function cartRewardsFingerprint(cart) {
  const items = (cart && cart.items) || [];
  return items
    .filter(it => String((it && it.handle) || "") !== "shipping-protection")
    .map(it => String(it.key || "") + "x" + String(it.quantity || 0))
    .join("|");
}

// ── 结算按钮上的应付额 ──────────────────────────────────────────────────────
// 按钮 = 主题算好的 Total + 车里已有的运费保障行 + （开关开着、保障行还没进车时）Xcotton 这一轮的保障费。
//
// 2026-10-23 Xcotton 改版（common v1-0-108，卡片 .xcotton_theme_defaultOn）：「加保障 / checkout without」
// 两颗按钮合成「卡片上的开关 + 一颗结算按钮」。旧版是插件自己把保障费写进它那颗按钮；新版不再改
// 按钮金额，开关打开时客户到结账页要多付保障费，按钮却只写商品 Total
// （实测 Total $67.15 + 保障 $1.45 开关开着，按钮 $67.15）。保障行此刻还不在车里（点结账时插件才加），
// 所以由主题把它算进按钮。
//
// 保障费读插件自己最近一次的算价结果（卡片上显示的就是它）。币种和车对不上或取不到时不加 ——
// 宁可少显示保障费，也不显示一个币种错的数。车里已有保障行时只算那一行，不再加，免得算两次。
let checkoutPayableTrusted = false; // 本轮 cartDataInit 金额校验通过才写按钮
function xcottonSwitchFeeCents(cart) {
  const cards = [...document.querySelectorAll('#xcottonWrapper')]
    .filter(card => getComputedStyle(card).display !== 'none');
  // 开关（defaultOn 的 .switch_btn）和别的卡片样式的勾选框都叫 #xcotton-switch，插件切换时给它们挂 checked
  if (!cards.some(card => card.querySelector('#xcotton-switch.checked, .switch_btn.checked'))) return 0;
  try {
    const result = window.__xcotton_common_seller__.processor.ShippingProtectionFlow
      .protection.lastCalculateData.result.computeResult;
    const cents = result.totalPriceInt;
    if (result.currency !== cart.currency || !Number.isSafeInteger(cents) || cents < 0) return 0;
    return cents;
  } catch (_) {
    return 0;
  }
}

function renderCheckoutPayable(force) {
  const preflight = window.THCartPreflight?.active ? window.THCartPreflight : null;
  if (preflight) {
    const clearAmount = () => $("[data-checkout-total]").empty().removeAttr('data-payable-cents');
    if (typeof cartData === 'undefined' || !cartData) { clearAmount(); return; }
    const stablePreflightValue = value => {
      if (Array.isArray(value)) return value.map(stablePreflightValue);
      if (value && typeof value === 'object') return Object.fromEntries(
        Object.keys(value).sort().map(key => [key, stablePreflightValue(value[key])]));
      return value;
    };
    const samePreflightValue = (left, right) => JSON.stringify(stablePreflightValue(left))
      === JSON.stringify(stablePreflightValue(right));
    const hasValidPreflightCartShape = cart => !!(cart
      && /^[A-Z]{3}$/.test(String(cart.currency || ''))
      && Array.isArray(cart.items) && cart.items.length > 0
      && cart.items.every(item => item && (item.variant_id || item.id) && item.key
        && Number.isSafeInteger(Number(item.quantity)) && Number(item.quantity) > 0)
      && (!Object.prototype.hasOwnProperty.call(cart, 'token') || !!cart.token)
      && (!Object.prototype.hasOwnProperty.call(cart, 'discount_codes') || Array.isArray(cart.discount_codes)));
    const hasCompletePreflightIdentity = cart => hasValidPreflightCartShape(cart)
      && !!cart.token && Array.isArray(cart.discount_codes);
    const incompleteCartMatchesDisplay = (cart, displayCart) => {
      if (!hasValidPreflightCartShape(cart) || !displayCart
          || !hasValidPreflightCartShape(displayCart) || cart.currency !== displayCart.currency) return false;
      if (Object.prototype.hasOwnProperty.call(cart, 'token') && cart.token !== displayCart.token) return false;
      if (Array.isArray(cart.discount_codes)) {
        const codes = values => [...new Set(values.map(item => String(typeof item === 'string' ? item : item?.code || '').trim().toLowerCase()).filter(Boolean))].sort();
        if (!samePreflightValue(codes(cart.discount_codes), codes(displayCart.discount_codes || []))) return false;
      }
      const itemIdentity = item => ({
        id: String(item.variant_id || item.id), key: String(item.key), quantity: Number(item.quantity),
        properties: item.properties || {},
        sellingPlan: item.selling_plan_allocation?.selling_plan?.id || null
      });
      // Xcotton can insert/remove its own protection line between Liquid and the
      // bridge's fresh read. Compare the shopper-controlled lines here; the quote's
      // fresh displayCart remains the authority for whether that fee is already included.
      const shopperItems = items => items.filter(item => !isShippingProtectionLine(item)).map(itemIdentity);
      if (!samePreflightValue(shopperItems(cart.items), shopperItems(displayCart.items))) return false;
      if (Object.prototype.hasOwnProperty.call(cart, 'note') && (cart.note || '') !== (displayCart.note || '')) return false;
      if (Object.prototype.hasOwnProperty.call(cart, 'attributes')
          && !samePreflightValue(cart.attributes || {}, displayCart.attributes || {})) return false;
      return true;
    };
    const completeIdentity = hasCompletePreflightIdentity(cartData);
    const validCartShape = hasValidPreflightCartShape(cartData);
    if (!validCartShape) { clearAmount(); return; }
    let prepared = typeof preflight.get === 'function' ? preflight.get(cartData) : null;
    if (!prepared && typeof preflight.getDisplayQuote === 'function') {
      prepared = preflight.getDisplayQuote(cartData);
      // Liquid's initial snapshot often lacks token/discount_codes. Only then may the
      // bridge's fresh, identity-validated display snapshot stand in for that incomplete
      // data, and only if every field Liquid did provide still matches that snapshot.
      // A complete or materially changed snapshot stays rejected.
      if (!prepared && !completeIdentity) {
        const displayQuote = preflight.getDisplayQuote();
        if (displayQuote?.displayCart && incompleteCartMatchesDisplay(cartData, displayQuote.displayCart)) prepared = displayQuote;
      }
    }
    if (!prepared || !Number.isSafeInteger(prepared.subtotalCents) || prepared.subtotalCents < 0
        || prepared.currency !== cartData.currency
        || (prepared.displayCart && prepared.displayCart.currency !== prepared.currency)) { clearAmount(); return; }
    // Prefer the native bridge's validated current cart. Liquid cartData can lag one render,
    // including the Xcotton protection line inserted during checkout preparation.
    const hasFreshDisplayCart = Array.isArray(prepared.displayCart?.items);
    const quoteCart = hasFreshDisplayCart ? prepared.displayCart : cartData;
    const protectionLines = (quoteCart.items || []).filter(isShippingProtectionLine);
    const protectionTotal = protectionLines
      .reduce((sum, item) => sum + (Number(item.final_line_price) || 0), 0);
    // Native subtotal already includes any protection row present in the prepared cart.
    const protectionAlreadyInQuote = hasFreshDisplayCart
      ? protectionLines.length > 0 : protectionTotal > 0;
    const fee = protectionAlreadyInQuote ? 0 : xcottonSwitchFeeCents(cartData);
    const payable = prepared.subtotalCents + fee;
    const symbol = window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon;
    const visibleAmount = `${symbol}${(payable / 100).toFixed(2)}`;
    const normalizedText = value => String(value || '').replace(/\s+/g, ' ').trim();
    const markup = `<span class="glc-money notranslate" translate="no">${visibleAmount}</span>`;
    $("[data-checkout-total]")
      .filter(function () {
        return this.getAttribute('data-payable-cents') !== String(payable)
          || normalizedText(this.textContent) !== normalizedText(visibleAmount);
      })
      .attr('data-payable-cents', payable)
      .html(markup);
    return;
  }
  if (!checkoutPayableTrusted || typeof cartData === 'undefined' || !cartData) return;
  const protectionTotal = (cartData.items || []).filter(isShippingProtectionLine)
    .reduce((sum, item) => sum + (Number(item.final_line_price) || 0), 0);
  const fee = protectionTotal > 0 ? 0 : xcottonSwitchFeeCents(cartData);
  const payable = cartData.total_price + protectionTotal + fee;
  // cartDataInit 里无条件写，不再只在金额变了时写：那个分支之外按钮会保留上一轮的
  // 旧值，满减生效后按钮比 Total 多 $50（2026-10-09 TH-QA-035 实测
  // Total $661.45 + 保障 $14.23，按钮却是 $725.68）。开关触发的重写只改变了的。
  $("[data-checkout-total]")
    .filter(function () { return force || this.getAttribute("data-payable-cents") !== String(payable); })
    .attr("data-payable-cents", payable)
    .html(`<span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${(payable / 100).toFixed(2)}</span>`);
}

// Xcotton may replace the button amount while retaining data-payable-cents. Install observers only
// after the controlled QA bridge is active; repair visible amount mismatches without rewriting GLC metadata.
let preflightCheckoutAmountObserverInstalled = false;
function installPreflightCheckoutAmountObserver() {
  if (preflightCheckoutAmountObserverInstalled || !window.THCartPreflight?.active || typeof MutationObserver !== 'function') return;
  preflightCheckoutAmountObserverInstalled = true;
  const observed = new WeakSet();
  const observer = new MutationObserver(() => {
    if (window.THCartPreflight?.active) renderCheckoutPayable(false);
  });
  const attach = node => {
    if (!node || node.nodeType !== 1) return;
    const targets = [];
    if (node.matches?.('[data-checkout-total]')) targets.push(node);
    targets.push(...node.querySelectorAll?.('[data-checkout-total]') || []);
    targets.forEach(target => {
      if (observed.has(target)) return;
      observed.add(target);
      observer.observe(target, {attributes:true, attributeFilter:['data-payable-cents'], childList:true, subtree:true, characterData:true});
    });
  };
  attach(document.documentElement);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(attach));
  }).observe(document.documentElement, {childList:true, subtree:true});
}
document.addEventListener('cart:preflight-confirmed', () => {
  installPreflightCheckoutAmountObserver();
  renderCheckoutPayable(true);
});
// Public mode may expose the bridge before the shopper engages it. Wait for the explicit
// cart event instead of installing a native-quote observer or changing the legacy CTA early.
document.addEventListener('cart:preflight-engaged', () => {
  if (!window.THCartPreflight?.active) return;
  installPreflightCheckoutAmountObserver();
  renderCheckoutPayable(true);
});
// The candidate bridge publishes explicit quote state so CTA consumers can clear a
// previously confirmed price as soon as a fresh quote is pending or rejected.
// cartDataInit adds a client-side synthetic B2B application to cartData when
// Shopify's native Cart has no order-level application. Keep the original
// Shopify application list for the later fresh-cart reconciliation; otherwise
// an exact fresh /cart.js read is incorrectly rejected against our own mutation.
document.addEventListener('cart:preflight-state', event => {
  const state = event?.detail?.state;
  if (!['pending', 'ready', 'error', 'empty', 'legacy-ready'].includes(state)) return;
  const clearAmount = () => $("[data-checkout-total]").empty().removeAttr('data-payable-cents');
  if (state === 'legacy-ready') {
    const fresh = event?.detail?.cart;
    const stable = value => {
      if (Array.isArray(value)) return value.map(stable);
      if (value && typeof value === 'object') return Object.fromEntries(
        Object.keys(value).sort().map(key => [key, stable(value[key])]));
      return value;
    };
    const same = (left, right) => JSON.stringify(stable(left)) === JSON.stringify(stable(right));
    const noCodes = cart => Array.isArray(cart?.discount_codes) && cart.discount_codes.length === 0;
    const itemIdentity = item => ({
      id: String(item.variant_id || item.id || ''), key: String(item.key || ''), quantity: Number(item.quantity),
      properties: item.properties || {}, sellingPlan: item.selling_plan_allocation?.selling_plan?.id || null,
      originalPrice: Number.isSafeInteger(Number(item.original_price)) ? Number(item.original_price) : null,
      lineDiscounts: (item.line_level_discount_allocations || []).map(allocation => ({
        amount: Number(allocation.amount), title: allocation.discount_application?.title || '',
        type: allocation.discount_application?.type || '', value: allocation.discount_application?.value ?? null,
        valueType: allocation.discount_application?.value_type || ''
      }))
    });
    const protectionIdentity = cart => (cart?.items || []).filter(isShippingProtectionLine).map(item => ({
      key: String(item.key || ''), quantity: Number(item.quantity), finalLinePrice: Number(item.final_line_price)
    }));
    const applicationIdentity = cart => (cart?.cart_level_discount_applications || []).map(app => ({
      title: app.title || '', type: app.type || '', value: app.value ?? null,
      valueType: app.value_type || '', targetType: app.target_type || '',
      targetSelection: app.target_selection || '', allocationMethod: app.allocation_method || ''
    }));
    const nativeApplicationSnapshot = typeof cartData !== 'undefined' && cartData
      ? window.__thCartNativeApplicationSnapshots?.get(cartData) : null;
    const applicationCart = nativeApplicationSnapshot
      ? {cart_level_discount_applications: nativeApplicationSnapshot} : cartData;
    const matches = typeof cartData !== 'undefined' && !!cartData && checkoutPayableTrusted
      && !window.THCartPreflight?.active && noCodes(fresh)
      && (!Array.isArray(cartData.discount_codes) || cartData.discount_codes.length === 0)
      && fresh.currency === cartData.currency
      && Array.isArray(fresh.items) && Array.isArray(cartData.items)
      && same(fresh.items.filter(item => !isShippingProtectionLine(item)).map(itemIdentity),
        cartData.items.filter(item => !isShippingProtectionLine(item)).map(itemIdentity))
      && same(protectionIdentity(fresh), protectionIdentity(cartData))
      && same(applicationIdentity(fresh), applicationIdentity(applicationCart));
    if (!matches) { clearAmount(); return; }
    // Use the already trusted theme calculation only after a fresh no-code Cart
    // snapshot reconciles with cartData. Never reuse the previous native subtotal.
    renderCheckoutPayable(true);
    return;
  }
  if (state === 'empty' && !window.THCartPreflight?.active) {
    clearAmount();
    return;
  }
  if (!window.THCartPreflight?.active) return;
  installPreflightCheckoutAmountObserver();
  renderCheckoutPayable(false);
});
installPreflightCheckoutAmountObserver();

// 开关切换、插件改完车后重算保障费（会重画卡片）都不经过 cartDataInit，所以单独盯着卡片。
// 卡片由插件异步插入，抽屉重绘后还会重建；body 上只看节点增删来找它，卡片内部才看属性和文字。
(function watchXcottonCard() {
  if (typeof MutationObserver !== 'function') return;
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; renderCheckoutPayable(false); }, 0);
  };
  const watched = new WeakSet();
  const cardObserver = new MutationObserver(schedule);
  const attach = () => document.querySelectorAll('#xcottonWrapper').forEach(card => {
    if (watched.has(card)) return;
    watched.add(card);
    cardObserver.observe(card, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true, characterData: true });
  });
  const isCard = node => node.nodeType === 1 && (node.id === 'xcottonWrapper' || !!node.querySelector('#xcottonWrapper'));
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes, ...record.removedNodes].some(isCard))) return;
    attach();
    schedule();
  }).observe(document.body, { childList: true, subtree: true });
  attach();
})();

function cartDataInit() {
  // Preserve Shopify's own order-level applications before legacy B2B math can
  // replace them with a synthetic theme-only Trade application.
  const nativeApplicationSnapshots = window.__thCartNativeApplicationSnapshots
    || (window.__thCartNativeApplicationSnapshots = new WeakMap());
  if (cartData && typeof cartData === 'object' && !nativeApplicationSnapshots.has(cartData)) {
    const applications = Array.isArray(cartData.cart_level_discount_applications)
      ? cartData.cart_level_discount_applications : [];
    nativeApplicationSnapshots.set(cartData, JSON.parse(JSON.stringify(applications)));
  }
  // 先撤销上一轮发布的奖励：本函数中途抛错时，宁可 Xcotton 少扣 $50，
  // 也不能让它拿着旧车的奖励去算新车（2026-10-09 TH-QA-036）。
  window.__thSpendReward = null;
  checkoutPayableTrusted = false;
  // Keep raw titles for metaobject matching; normalize only classification comparisons.
  const normalizeDiscountTitle = title => decodeHtmlEntities(String(title ?? '')).trim().toLowerCase();
  const orderDiscountTitles = new Set((cartData.cart_level_discount_applications || []).map(dc => normalizeDiscountTitle(dc.title)));
  const isOrderDiscount = title => orderDiscountTitles.has(normalizeDiscountTitle(title));
  // 当前客户类型
  var currentCustomerType = customer.isB2B ? "B2B" : "C";

  var isHasProductCoupon = [];
  // 商品级折扣摘要：标题 -> 主题实际扣掉的分
  const productDiscountByTitle = {};


  $(".cart-shipping__message.cart-shipping__message_default").removeClass(
    "active",
  );
  $(".cart-shipping__message.cart-shipping__message_success").removeClass(
    "active",
  );

  if ($("#CartDrawer .cart-item").length > 0 || cartData.items.length > 0) {
    $("#CartDrawer cart-drawer-items").removeClass("is-empty");
    $(".drawer__inner-empty").hide();
    $(".drawer__footer").show();
  } else {
    $("#CartDrawer cart-drawer-items").addClass("is-empty");
    $(".drawer__inner-empty").show();
    $(".drawer__footer").hide();
  }

  // 全局折扣
  var origin_discounts = 0;
  // 折扣
  var totalDiscount = 0;

  // 总价
  // var totalPrice = cartData.original_total_price;
  var totalPrice = 0,
    subTotal = 0,
    rewardsBasePre = 0,
    rewardsBasePost = 0,
    original_total_price = 0,
    // Subtotal 的展示值，只用于渲染，不参与门槛/B2B 计算。
    // 不能复用 original_total_price：它累加的是 /cart.js 的 item.price（已扣行级折扣），
    // 而 Liquid 的 total_original_price（cart-drawer.liquid:170）用的是折前 item.original_price。
    // 两者混用会让 Subtotal 首屏显示折前、任何一次交互后跳成折后。
    subtotal_display = 0;

  $.each(cartData.items, function (i, item) {
    if (isShippingProtectionLine(item)) return;
    var price = item.price * item.quantity || 0,
      newPrice = 0,
      discountPrice = 0,
      propertyPriceTotal = 0,
      oldPrice = 0;
    // Only the explicit trailing VO price suffix is monetary data.
    $.each(item.properties, function (_, property) {
      const values = Array.isArray(property) ? property : [property];
      values.forEach(value => {
        const cents = cartPropertyCents(value) * item.quantity;
        propertyPriceTotal += cents;
        price += cents;
      });
    });

    // rawItemPrice 上面已经乘过 item.quantity，这里不能再乘一次。
    // 必须在下面覆写 cartData.items[i] 的价格字段之前读 item.original_price。
    subtotal_display += item.original_price * item.quantity + propertyPriceTotal;

    // 折前价
    oldPrice = cartData.items[i].oldPrice = price;
    original_total_price = original_total_price + cartData.items[i].oldPrice


    var discountList = [],
      couponType = false;
    $.each(
      $(`.cart-item[data-key="${item.key}"] .discounts li`),
      function (j, discount) {
        const title =
          discount.title ||
          decodeHtmlEntities($(discount).text().trim().toLowerCase());
        if (!isOrderDiscount(title) && !discountList.includes(title)) {
          couponType = true;
          discountList.push(title);
        }
      },
    );

    var defaultB2BType = false;
    $.each(
      cartData.cart_level_discount_applications,
      function (j, cartCoupon) {
        var matchFound = false;

        $.each(default_coupon_list, function (z, defaultCoupon) {
          if (defaultCoupon.coupon == cartCoupon.title) {
            defaultB2BType = true;
            matchFound = true;
            return false;
          }
        });

        if (matchFound) return false;
      },
    );

    // 如果是B端用户且有使用默认的订单折扣，清空折扣，在后续的代码中添加对应的门槛折扣
    if (currentCustomerType == "B2B" && defaultB2BType) {
      cartData.cart_level_discount_applications = [];
    }

    // 产品折扣
    var coupon_product = [];
    if (item.discounts.length > 0) {
      $.each(item.discounts, function (j, extraItem) {
        const title = String(extraItem.title ?? '');
        if (!isOrderDiscount(title)) {
          discountList = discountList.filter(discountCode => normalizeDiscountTitle(discountCode) !== normalizeDiscountTitle(title));
          // A code's digits are identifiers, not money. Shopify amounts are cents.
          // 券码中的数字只是标识；原生行级记录明确给出百分比或固定金额。
          // 兼容缺少 allocations 的旧数据时才沿用标题兜底，不能把 VO 加价漏掉。
          // Public preflight is retail-only. Preserve MAIN's legacy metadata/title
          // classification on the existing B2B estimate path.
          // 仅公开零售预检加载 bridge；没有 bridge 的 legacy/B2B/TOB 路径保持 MAIN 的标题兼容行为。
          const nativeApplication = window.THCartPreflight?.active !== true || currentCustomerType === 'B2B' ? null
            : (item.line_level_discount_allocations || [])
              .map(allocation => allocation.discount_application)
              .find(application => application && ['percentage', 'fixed_amount'].includes(application.value_type)
                && normalizeDiscountTitle(application.title) === normalizeDiscountTitle(title));
          const nativePercentage = nativeApplication && Number(nativeApplication.value);
          const percentage = nativeApplication
            ? nativeApplication.value_type === 'percentage' && Number.isFinite(nativePercentage) && nativePercentage >= 0 && nativePercentage <= 100
            : /\d+(?:\.\d+)?\s*%/.test(title);
          const amount = Number(extraItem.amount);
          coupon_product.push({
            title: extraItem.title,
            value: percentage ? (nativeApplication ? nativePercentage : matchNum(title)) : Number.isFinite(amount) && amount >= 0 ? amount : 0,
            value_type: percentage ? 'percentage' : 'fixed_amount',
          });
        }
      });
    }

    if (discountList.length > 0) {
      $.each(discountList, function (j, extraItem) {
        coupon_product.push({
          title: extraItem.title,
          value: matchNum(extraItem),
          value_type: extraItem.includes("%") ? "percentage" : "",
        });
      });
    }

    // 先取值再归一化，不能直接拿 .attr() 去比较：DOM 里没有对应行时 .attr() 返回
    // undefined，而 undefined != 0 是 true，会把 undefined 当成折扣率算进去，
    // undefined / 100 = NaN 会一路污染到 cartData.total_price，底部和结算按钮显示 $NaN。
    // matchNum 对空值/非数字返回 0，取不到就按"无折扣"降级。
    // 注意 data-item-id 是 variant ID 不是行 ID，同 variant 多定制属性会撞号，
    // .first() 只是让取值确定化；根治要改成 item.key，另行处理。
    const couponValue = matchNum(
      $(`.cart-item[data-key="${item.key}"]`).first().attr("data-coupon"),
    );

    if (coupon_product.length === 0 && couponValue > 0) {
      coupon_product.push({
        value: couponValue,
        value_type: "percentage",
      });
    }

    // 计算折扣
    var default_coupon = [];
    // console.log('开始计算产品折扣', price);
    $.each(coupon_product, function (j, coupon) {
      var coupon_price = 0;
      // console.log('价格', price, 'coupon', coupon);
      if (coupon.value_type == "percentage") {
        couponType = true;
        default_coupon = coupon;
        const amount = coupon.value / 100;
        coupon_price = price * amount;
      } else {
        couponType = true;
        default_coupon = coupon;
        coupon_price = coupon.value;
      }
      price -= coupon_price;
    });
    // console.log('coupon_product: ' + coupon_product)

    if (item.discounts.length > 0 || couponType) {
      $.each(item.discounts, function (j, discount) {
        if (!isHasProductCoupon.includes(discount.title)) {
          isHasProductCoupon.push(discount.title);
        }
        if (!isHasProductCoupon.includes(default_coupon.title)) {
          isHasProductCoupon.push(default_coupon.title);
        }
      });
      newPrice = price;
    }

    const currentPrice =
      item.discounts.length > 0 || couponType ? newPrice : oldPrice;

    // 计算除订单折扣外的价格
    const currentOldPrice = currentPrice + discountPrice;
    subTotal += currentOldPrice;

    // 奖励阶梯（免运费 / 满减）的基数：商品折扣后的商品金额，**含定制属性加价**。
    // 为什么不能用 cart.items_subtotal_price：原生字段只认 variant 价，定制窗帘的
    // 真实金额在 line item properties 里（Lining | $100 这种），两者差得很远 ——
    // Hussein 两件原生 $241.40、实际报价 $875.50。原生购物车用低的那个判门槛，
    // 但真正收钱的草稿单用高的那个（2026-10-09 实测草稿单 #D15743：
    // $1,030 × 85% − $50 = $825.50）。进度条必须跟草稿单一个口径，否则会告诉
    // 顾客"还差 $358"而结账时其实早就达标了。
    // 排除：Xcotton 运费保障行（由保障卡片自己算）、购买礼品卡（Shopify 的订单
    // 折扣最低消费在商品折扣前就把购卡金额排除在外）。
    // Shopify 的订单折扣最低消费是**两道门槛**，不是一道（官方：Minimum purchase
    // amount for amount off order discounts）：
    //   ① 商品折扣**前**、**排除**购买礼品卡的商品额 >= 门槛
    //   ② 商品折扣**后**、**包含**礼品卡的小计   >= 门槛
    // 两道都过才有资格。之前一刀切永久排除礼品卡，$650 商品打 15% 后 $552.50
    // 加 $50 购卡（两道其实都过）会被误算成还差 $47.50。
    // 折前用 oldPrice（483 行 `// 折前价`，含定制属性加价），不是 currentOldPrice。
    // currentOldPrice = currentPrice + discountPrice，而 discountPrice 在这个循环里
    // 从声明到结束就没被累加过（465 行声明，929/933 是后面 savings 的另一个作用域），
    // 所以它恒等于 currentPrice，pre 和 post 会永远相等 —— $650×85% 实测两个都是
    // 55250，第二道门槛形同虚设（2026-10-09 TH-QA-022 复测未过）。
    if (!isShippingProtectionLine(item)) {
      if (!item.gift_card) rewardsBasePre += oldPrice;
      rewardsBasePost += currentPrice;
    }

    // 商品级折扣按标题累计，给购物车摘要出行用。
    // 金额只能用主题自己算的 oldPrice - currentPrice：Shopify 的
    // discountItem.amount 是按 variant 价算的（这单 $241.40 的 15% = $36.21），
    // 而主题按含定制加价的 $1,030 扣了 $154.50，拿原生金额出行对不上 Total。
    if (!isShippingProtectionLine(item) && coupon_product.length) {
      const cut = oldPrice - currentPrice;
      if (cut > 0) {
        const label = coupon_product.map(c => c.title).filter(Boolean).join(' + ');
        if (label) productDiscountByTitle[label] = (productDiscountByTitle[label] || 0) + cut;
      }
    }


    cartData.items[i].original_discountPrice = currentOldPrice;
    cartData.items[i].original_line_price = currentPrice;
    // 这里原本还会把 cartData.items[i].original_price 覆写成折后单价。它篡改了
    // Shopify 定义好的字段语义（original_price = 折前单价），仓库内没有任何读者，
    // 但会让上面 subtotal_display 依赖的折前价在"同一份 cartData 被重复 init"时
    // 悄悄变成折后价。已删除，不要恢复。

    // if (customerType) {
    //   // cart Page
    //   $(`.bcpo-cart-item-line-price[data-key="${item.key}"]`).closest('.cart-item__totals, .cart-item__total-price').html(`${window.Shopify.currency.icon}${(cartData.items[i].original_discountPrice / 100).toFixed(2)}`);
    // }
    totalPrice +=
      item.discounts.length > 0 || couponType ? newPrice : oldPrice;
  });

  totalPrice += origin_discounts;

  // console.log('default_coupon_list: ' + JSON.stringify(default_coupon_list, null, 2))

  const orderCoupons = default_coupon_list.filter((defaultCoupon) => {
    const doorsill = defaultCoupon.doorsill * 100;
    const couponType =
      defaultCoupon.customer_type == "All" ||
      currentCustomerType == defaultCoupon.customer_type;
    return (
      couponType &&
      defaultCoupon.coupon_type == "Order Coupon" &&
      original_total_price >= doorsill
    );
  });


  // console.log('orderCoupons: ' + JSON.stringify(orderCoupons, null, 2))



  let syntheticB2BDiscount = null;
  if (orderCoupons.length > 0 && currentCustomerType == "B2B") {

    const productCoupons = orderCoupons.filter((coupon) => {
      if (coupon.customer_type != "B2B") {
        return isHasProductCoupon.includes(coupon.coupon);
      }
    });
    // console.log(isHasProductCoupon, productCoupons);
    // console.log('productCoupons: ' + productCoupons)
    if (productCoupons.length == 0) {
      // 获取符合条件的最大门槛
      const maxValue = Math.max(
        ...orderCoupons.map((coupon) => coupon.doorsill),
      );
      const result = orderCoupons.filter(
        (coupon) => Number(coupon.doorsill) === maxValue,
      );
      cartData.cart_level_discount_applications = [
        {
          title: result[0].coupon,
          target_selection: "all",
          target_type: "line_item",
          value: result[0].coupon_value,
          value_type: result[0].coupon_unit == "%" ? "percentage" : "fixed_amount",
        },
      ];
      syntheticB2BDiscount = cartData.cart_level_discount_applications[0];
    }
  }



  // console.log(cartData.cart_level_discount_applications);

  const discountCodeType = cartData.cart_level_discount_applications.filter(
    (item) => {
      return item.type != "";
    },
  );


  // console.log('original_total_price: ' + original_total_price)

  $.each(cartData.cart_level_discount_applications, function (i, item) {
    const discount = item.value_type === 'percentage'
      ? Math.round(totalPrice * (Number(item.value) / 100))
      : Number.isFinite(Number(item.total_allocated_amount))
        ? Number(item.total_allocated_amount) : Math.round(Number(item.value) * 100);
    item.total_allocated_amount = Math.min(Math.max(0, discount), Math.max(0, totalPrice - totalDiscount));
    totalDiscount += item.total_allocated_amount;
  });

  cartData.total_discount = totalDiscount;
  cartData.original_total_price = original_total_price;
  // 奖励阶梯基数，两道门槛各一个。含定制属性加价，已排除 Xcotton 保障行。
  // rewards_base 保留为折后口径，免运费进度条用它。
  cartData.rewards_base_pre = rewardsBasePre;   // 折前、不含购卡
  cartData.rewards_base_post = rewardsBasePost; // 折后、含购卡
  cartData.rewards_base = rewardsBasePost;

  // console.log('totalDiscount: ' + totalDiscount)
  // console.log('subTotal: ' + subTotal)

  // 折后价
  // console.log(totalPrice, totalDiscount);
  cartData.total_price = totalPrice - totalDiscount;
  // cartData.total_price = totalPrice;


  let hasAnyItemBiggerThanAll = ''

  // 新增判断
  if (currentCustomerType == 'B2B' && orderCoupons.length > 0) {

    const product_disount_list = []
    var dicount_total_price = 0
    let availableDiscount = 1;


    // 判断当前购物车总原价使用哪个B2B订单折扣，按门槛从高到低排序，取最大可用折扣
    const sortedCoupons = [...orderCoupons].sort((a, b) => b.doorsill - a.doorsill);
    for (const coupon of sortedCoupons) {
      if (original_total_price >= coupon.doorsill * 100) {
        availableDiscount = coupon.coupon_unit === '%'
          ? Math.max(0, 1 - Number(coupon.coupon_value) / 100)
          : Math.max(0, 1 - Number(coupon.coupon_value) * 100 / original_total_price);
        break;
      }
    }

    // console.log('availableDiscount: ' + availableDiscount)

    // 获取所有产品折扣
    $.each(cartData.items, function (i, item) {
      if (isShippingProtectionLine(item)) return;
      dicount_total_price += item.original_line_price
      $.each(item.discounts, function (index, discountItem) {
        var discount = isOrderDiscount(discountItem.title) ? null : matchDiscount(discountItem.title || '')
        product_disount_list.push(discount)
      })
    });

    // console.log(product_disount_list)
    // console.log(JSON.stringify(orderCoupons, null, 2))

    // 获取B2B订单折扣
    const couponValues = orderCoupons.map(item => item.coupon_value);

    // 判断每一项产品折扣是否有大于B2B订单折扣的，如果有就优先使用产品折扣
    hasAnyItemBiggerThanAll = product_disount_list.some(pdVal => {
      return couponValues.every(cv => pdVal > cv);
    });

    // B2B 是「二选一」：要么商品折扣赢、要么整单折扣赢，total_price 只按赢的那个算。
    // 摘要必须跟着走，否则两边都列一遍，加起来对不上 Total
    // （2026-10-09 TH-QA-033：$4000 车 Total 正确 $3200，摘要却列了 −$600 和 −$800）。
    if (hasAnyItemBiggerThanAll) {
      cartData.total_price = dicount_total_price
      // 商品折扣赢：整单折扣没生效，摘要里不能出现它
      cartData.cart_level_discount_applications = [];
      syntheticB2BDiscount = null;
      $('.cart-drawer').addClass('hide_discount')
    } else {
      cartData.total_price = Math.round(original_total_price * availableDiscount)
      cartData.total_discount = original_total_price - cartData.total_price
      if (syntheticB2BDiscount) syntheticB2BDiscount.total_allocated_amount = cartData.total_discount;
      // 整单折扣赢：商品折扣被丢弃了（total_price 是拿原价重算的），摘要也要清掉
      Object.keys(productDiscountByTitle).forEach(k => { delete productDiscountByTitle[k]; });
      $('.cart-drawer').removeClass('hide_discount')
    }


  }

  // 金额有效性统一在这里判定：必须排在 B2B 最终金额算完之后、任何金额字符串生成之前。
  // 三个值要分别 Number.isFinite()，不能写成 isFinite(a && b && c)——&& 只会把最后一个
  // 操作数交给它，而全局 isFinite() 还会做隐式转换。0 是合法金额（空车、无折扣）。
  // 无效时只跳过金额输出，商品数量、空车状态、结算按钮态、优惠码名称与事件绑定、
  // 小样逻辑、B2B 显隐必须照常执行，否则会用一个显示问题换掉一批功能。
  const hasValidTotals =
    Number.isFinite(subtotal_display) &&
    Number.isFinite(cartData.total_price) &&
    Number.isFinite(cartData.total_discount);

  // 满减：资格判定和奖励条共用 cartSpendRewardState。放在这里是因为上面的 B2B
  // 分支还会覆写 total_price，必须等它定下来；而又要赶在任何金额字符串生成之前。
  const spendReward = hasValidTotals ? cartSpendRewardState(cartData) : { eligible: false, amount: 0 };
  if (spendReward.eligible && spendReward.amount > 0) {
    const applied = Math.min(spendReward.amount, Math.max(0, cartData.total_price));
    spendReward.applied = applied;
    cartData.total_price -= applied;
    cartData.total_discount += applied;
  } else {
    spendReward.applied = 0;
  }
  cartData.spend_reward_applied = spendReward.applied;

  if (!hasValidTotals) {
    console.error("Invalid cart totals:", {
      subtotal_display: subtotal_display,
      total_price: cartData.total_price,
      total_discount: cartData.total_discount,
      cartData: cartData,
    });
  }

  $(".coupon .msg, .coupon .success").css("display", "none");
  var couponStr = [],
    discountStr = [],
    couponNum = 0;
  // 商品级折扣先出行。以前这里只遍历 cart_level_discount_applications，
  // 商品折扣一行都没有，顾客看到 Subtotal $1030 / Total $875.50 中间凭空少了
  // $154.50，不知道被扣了什么（2026-10-09 用户反馈）。
  Object.keys(productDiscountByTitle).forEach(function (title) {
    const cents = productDiscountByTitle[title];
    if (!Number.isFinite(cents) || cents <= 0) return;
    discountStr.push('<li class="discounts__discount">');
    discountStr.push(
      `<div>${escapeHtml(title)}</div><span class="discounts__amount"><span class="glc-money notranslate" translate="no" style="opacity:1;">-${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${(cents / 100).toFixed(2)}</span></span>`,
    );
    discountStr.push('</li>');
  });

  // 满减行。它不在 cart_level_discount_applications 里 —— Shopify 原生购物车按
  // variant 价判门槛、够不到 $600，是主题按草稿单口径自己应用的。
  if (spendReward.applied > 0) {
    discountStr.push('<li class="discounts__discount" data-spend-reward>');
    discountStr.push(
      `<div>${escapeHtml(spendReward.label || 'Spend reward')}</div><span class="discounts__amount"><span class="glc-money notranslate" translate="no" style="opacity:1;">-${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${(spendReward.applied / 100).toFixed(2)}</span></span>`,
    );
    discountStr.push('</li>');
  }

  $.each(cartData.cart_level_discount_applications, function (i, item) {

    const price = (Math.max(0, Number(item.total_allocated_amount) || 0) / 100).toFixed(2);

    if (item.type != "") {
      couponNum++;
      couponStr.push(
        `<div data-coupon="${item.title.toLowerCase()}">${item.title}`,
      );
      couponStr.push(
        `<span class="close"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M9.33331 9.3335L22.6666 22.6668" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><path d="M9.33331 22.6668L22.6666 9.3335" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path></svg></span>`,
      );
      couponStr.push(`</div>`);
    }
    discountStr.push(`<li class="discounts__discount" test="222">`);
    discountStr.push(
      `<div>${escapeHtml(item.title)}</div><span class="discounts__amount"><span class="glc-money notranslate" translate="no" style="opacity:1;">-${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${price}</span></span>`,
    );
    discountStr.push(`</li>`);
  });

  // console.log('couponStr: ' + couponStr)
  // console.log('discountStr: ' + discountStr)

  if (cartData.item_count > 0) {
    $(".drawer__inner-empty").css("display", "none");
    $(".drawer cart-drawer-items").removeClass("is-empty");
    $(".header__cart .cart-count-bubble").html(
      `<span aria-hidden="true">(${cartData.item_count})</span><span class="visually-hidden">${cartData.item_count} items</span>`,
    );
  }

  // 摘要容器：抽屉和 /cart 页都要有。
  // /cart 的 .discounts__wrapper 在 main-cart-items.liquid:754 被
  // `cart_level_discount_applications.size > 0` 挡着 —— 没有原生订单折扣时容器不存在，
  // 商品折扣和满减两行就都填不进去，进了购物车页折扣明细全消失
  // （2026-10-09 TH-QA-034）。这里按需补容器。
  const UL = '<ul class="discounts list-unstyled notranslate" role="list" aria-label="Discount"></ul>';
  if ($("#CartDrawer .totals ul.discounts").length === 0) {
    $("#CartDrawer .totals").append(UL);
  }
  // /cart 页：优先用已有 wrapper，没有就建在小计下面
  if ($(".discounts__wrapper > ul.discounts").length === 0) {
    const wrapper = $(".discounts__wrapper");
    if (wrapper.length) {
      wrapper.append(UL);
    } else {
      const anchor = $("#main-cart-items .subtotalPrice, #main-cart-footer .subtotalPrice").last();
      if (anchor.length) anchor.after('<div class="discounts__wrapper">' + UL + '</div>');
    }
  }

  // discountStr 里带金额（-$X），金额无效时整块跳过。
  // 已知降级：这句 .html() 同时承担"清空"职责，跳过后已失效的折扣行会暂时留在界面上，
  // 直到下一次有效重算或页面刷新。删除路径下 .drawer__inner 是服务端刚整块渲染的，
  // 留下的是正确内容；加购路径下才可能短暂陈旧。
  if (hasValidTotals) {
    $(".discounts__wrapper > ul, #CartDrawer .totals ul.discounts").html(
      discountStr.join(""),
    );
    applyDiscountCollapse();
  }
  // couponStr 只有优惠码名称，不含金额，照常渲染
  $(".coupon .couponList")
    .html(couponStr.join(""))
    .css("display", couponNum > 0 ? "flex" : "none");

  if (localStorage.getItem("discount_code") != null) {
    const discountCode = JSON.parse(localStorage.getItem("discount_code"));
    var discountNotType = discountCode.discountArr,
      discountType = [];
    $.each(cartData.cart_level_discount_applications, function (i, item) {
      // arrDel(discountNotType, item.title.toLowerCase());
      if (discountCode.couponName.toLowerCase() == item.title.toLowerCase()) {
        discountType.push(item);
      }
    });
    var productDiscount = [];
    $.each(cartData.items, function (i, item) {
      const type = item.discounts.filter((discount) => {
        return discountCode.discountArr.includes(
          discount.title.toLowerCase(),
        );
      });
      if (type.length > 0) {
        productDiscount.push({
          index: i,
          title: type[0].title,
          oldPrice: item.oldPrice,
          line_level_total_discount: item.line_level_total_discount,
        });
        discountType.push({
          title: type[0].title,
          total_allocated_amount: type[0].amount,
        });
      }
    });
    // console.log(productDiscount, discountNotType);
    $.each(productDiscount, function (i, item) {
      const old = Number(item.oldPrice) / 100;
      const newProductPrice =
        (Number(item.oldPrice) - Number(item.line_level_total_discount)) / 100;
      // 逐行价格另做局部校验：line_level_total_discount 不参与上面三个汇总值的计算，
      // 汇总金额全部有限时它仍可能异常，只靠 hasValidTotals 拦不住这里的 $NaN。
      if (
        hasValidTotals &&
        Number.isFinite(old) &&
        Number.isFinite(newProductPrice)
      ) {
        $(".cart-item")
          .eq(item.index)
          .find(".cart-item__price-wrapper")
          .html(
            `<dl class="cart-item__discounted-prices"><span class="cart-item__old-price price"><span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${old.toFixed(2)}</span></span><dd><span class="bcpo-cart-item-line-price price price_sale"><span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newProductPrice.toFixed(2)}</span></span></dd></dl>`,
          );
      }
      // 折扣角标不含金额，照常渲染
      $(".cart-item")
        .eq(item.index)
        .find(".discounts")
        .append(
          `<li class="discounts__discount"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12" width="12" height="12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>${item.title.toUpperCase()}</li>`,
        );
    });

    if (discountType.length > 0) {
      let arr = [],
        discountPrice = 0;
      $.each(discountType, function (i, item) {
        arrDel(discountNotType, item.title);
        arr.push(item.title.toUpperCase());
        discountPrice += item.total_allocated_amount;
      });
      // savings 同样要局部校验：discountPrice 有一部分来自 item.discounts[].amount
      // （上面 total_allocated_amount: type[0].amount 那条），它不经过任何汇总计算，
      // 汇总值有限时这里仍可能是 NaN。
      const savings = discountPrice / 100;
      if (hasValidTotals && Number.isFinite(savings)) {
        $(".coupon .success span:first-of-type").html(
          `Coupon code '${arr.join(",")}' applied, you saved ${window.Shopify.currency.icon}${savings.toFixed(2)}!`,
        );
      }
    }
    if (discountNotType.length > 0) {
      $(".coupon .msg").html(
        `Coupon code '${discountNotType.join(",").toUpperCase()}' has expired or is not applicable. Please try again.`,
      );
    }
    $(".coupon .msg").css(
      "display",
      discountNotType.length > 0 ? "flex" : "none",
    );
    $(".coupon .success").css(
      "display",
      discountType.length > 0 ? "flex" : "none",
    );
    localStorage.removeItem("discount_code");
  }

  if (hasValidTotals) {
    // 抽屉底部整块不在 cart-drawer-items 里（cart-drawer.liquid:772 就结束了），
    // 加购走的 onCartDrawerUpdate() 只换商品节点，所以 Subtotal 必须由 JS 补更新。
    // 旧选择器 .totals__subtotal-value 现在只存在于 *-hulkapps-backup.liquid，
    // 线上真实类名是 .subtotalPrice —— 这就是 Subtotal 一直停在旧值的原因。
    // 只限定抽屉：/cart 页的 Subtotal 由 .js-contents-totals 整块重渲染，
    // 不需要 JS 兜，多一个写入源反而会和 section 更新互相覆盖。
    $("#CartDrawer .subtotalPrice").html(
      `<span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${(subtotal_display / 100).toFixed(2)}</span>`,
    );

    // 结构必须和 Liquid 一字不差（cart-drawer.liquid:842 / main-cart-items.liquid:790）：
    //   <span>Total</span><span class="totalPrice">$X</span>
    // 以前 JS 多给 .totalPrice 加了 glc-money，下面那句又往里套了一层 .glc-money，
    // 重建后的层级和首屏不一样，"Total" 和金额会挤成 "Total$875.50"、字号也不对。
    const totalMoney =
      `${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${(cartData.total_price / 100).toFixed(2)}`;
    // 里面那层 .glc-money 必须留着：它是货币 app 的转换钩子，拿掉之后切英镑
    // 小计和折扣都换算了、Total 还停在美元（2026-10-09 TH-QA-039）。
    // 但只留**一层** —— 以前外层 .totalPrice 也挂 glc-money、里面再套一个，
    // 两个钩子加上层级不一致才是 "Total$875.50" 的来源。
    const totalHtml =
      `<span>Total</span><span class="totalPrice"><span class="glc-money notranslate" translate="no">${totalMoney}</span></span>`;
    if ($(".cart_Total").length > 0) {
      // 保留 Liquid 写在第一个 span 上的 data-current_order，别的脚本在读
      $(".cart_Total").each(function () {
        const attr = $(this).find("span[data-current_order]").attr("data-current_order");
        $(this).html(totalHtml);
        if (attr !== undefined) $(this).find("span").first().attr("data-current_order", attr);
      });
    } else {
      // 以前这里 $(".totals").after() 插一个新 .cart_Total。那个位置和 Liquid 的不同
      // （Liquid 的在 .totals 的兄弟层、外面还有 .cart-drawer__summary 之类的作用域），
      // 插出来的节点拿不到按祖先限定的规则，就是没样式的那一行。
      // 两处消费者的 Liquid 都一定会渲染 .cart_Total，取不到说明 DOM 还没就绪 ——
      // 这时什么都不做，等下一轮；插一个没样式的比不插更糟。
    }
    // .totalPrice 同时挂在结算按钮上（cart-drawer.liquid:963），这句一并覆盖。
    // 排除 .cart_Total 里的那颗 —— 上面刚按 Liquid 结构写过，再写会多套一层 glc-money。
    $(".totalPrice").not(".cart_Total .totalPrice").html(
      `<span class="glc-money notranslate" translate="no">${totalMoney}</span>`,
    );
    // 结算按钮（[data-checkout-total]）显示客户实际要付的，见 renderCheckoutPayable。
    checkoutPayableTrusted = true;
    renderCheckoutPayable(true);

    // ── 把满减接进 Xcotton 的算价通道 ─────────────────────────────────────────
    // Xcotton 给按钮算价走的是它自己的 handleCartData（layout/theme.liquid 里已经为它
    // 打过一个补丁），**不读 DOM 属性**。满减是主题客户端应用的、不在 Shopify 的
    // cart_level_discount_applications 里（原生购物车按 variant 价判门槛，够不到 $600），
    // 所以 Xcotton 拿的是减之前的数，按钮比 Total 多 $50
    // （2026-10-09 TH-QA-035：Total $661.45 + 保障 $14.23，按钮却 $725.68）。
    //
    // 这里只发布权威值；注入由 theme.liquid 的 wrapper 在**传给 Xcotton 的那份副本**上做，
    // 不能写回 cartData —— 写回去主题自己的 cartRewardsHasOrderDiscount 会把它当成
    // 「已有订单级折扣」而拒绝满减，自相矛盾。
    window.__thSpendReward = spendReward.applied > 0
      ? {
          cents: spendReward.applied,
          title: spendReward.label || 'Spend reward',
          // 绑定这辆车。wrapper 收到的 cart 指纹对不上就不用这份奖励 ——
          // 否则改数量后它会把旧车的 $50 扣到新车上（TH-QA-036）。
          fp: cartRewardsFingerprint(cartData),
        }
      : null;
    // 这个属性主题自己不读，留着只是让 DOM 和 Total 一致，不是 Xcotton 的通道。
    $("#CartDrawer-CartItems").attr("data-total-discount-price", cartData.total_price);
  }

  // 以下不涉及金额，任何情况下都要执行
  $(".drawer__footer").css(
    "display",
    cartData.items.length > 0 ? "block" : "none",
  );
  $("#CartDrawer-Checkout").attr("disabled", cartData.items.length == 0);
  if (cartData.items.length == 0) {
    $("#CartDrawer cart-drawer-items").addClass("is-empty");
  }

  // 奖励阶梯（免运费 + 满减）。文案里带金额，同样受校验保护。
  // 已知降级：金额取不到时整块不显示，而不是显示错的金额。
  updateCartRewards(cartData, hasValidTotals);

  swatchCartChange();
  Product_swatchCartChange();
  // 不依赖金额，所以放在 hasValidTotals 判断之外：金额取不到时提示照样准。
  updateSwatchOnlyNotice(cartData);

  // subtotalChange();


  if (currentCustomerType == 'B2B') {
    const $discountWrap = $('.cart-drawer__footer .discounts');
    if (hasAnyItemBiggerThanAll) {
      $discountWrap.addClass('hide');
    } else {
      $discountWrap.removeClass('hide');
    }
  }

  // 金额是否渲染成功，交给 cartDataChange 决定要不要重取一次
  return hasValidTotals;
}

// 首屏这次是裸调用，不经过 cartDataChange，所以金额无效时不会自动重取。
// 这没问题：此时 DOM 里是 Liquid 渲染的服务端金额，本来就是对的，
// 下一次购物车交互走 cartDataChange 会带上恢复逻辑。
try { cartDataInit(); } catch (error) { console.error("Cart display initialization failed:", error); }

// 什么算"一片免费小样"—— 全站唯一判定，按 handle/url，不按标题。
//
// 以前三处用的是 item.title.includes('Swatch')，会把 10 个 $5.00 的付费色卡本
// （"Cassie Linen Blend Swatch Book — 21 Colors" 之类）也算成免费小样：
// 买一本色卡本就白白吃掉一个免费额度，还会出现在 Selected Swatches 清单里，
// 而产品页那边（page_product_gallery.js 的封顶）早就改成按 handle 判了，两边对不上。
//
// 线上核对过（2026-08-27）：101 个免费小样产品的 handle **全部**含复数 'swatches'；
// 10 个付费色卡本的 handle 全是单数 '-swatch-'，一个都不含 'swatches'。
// 所以这个判定能把两拨干净分开。
function isSwatchLineItem (item) {
  return (item.handle || '').includes('swatches') || (item.url || '').includes('swatches');
}

// 整车全是小样时的提示（购物车页 + 侧边购物车）。
// 首屏由 snippets/cart-swatch-only-notice.liquid 用 Liquid 渲染好 active，
// 这里只在加购/改数量/删除之后就地切 class —— 用的是已经取回来的 cartData，
// 不额外发请求、不重渲染 section。
//
// ⚠ 口径和上面的 isSwatchLineItem **不一样**，别合并：
// isSwatchLineItem 答的是"算不算一片免费小样"（10 片封顶要用），付费色卡本必须排除；
// 这里答的是"是不是小样商品"，$5 的色卡本也算。
// 色卡本的 handle 没有共同子串（单数 -swatch-book- / -booklet-swatch-），认不了，
// 所以名单由 Liquid 从 Swatch Book 集合（智能集合，tag = Booklet Swatch）算好，
// 写在提示元素的 data-swatch-handles 上 —— /cart.js 的行项目里没有 tags。
function isSwatchProductLineItem(item, bookHandles) {
  if (isSwatchLineItem(item)) return true;
  return bookHandles.has(item.handle || '');
}

function updateSwatchOnlyNotice(cart) {
  const $notice = $('.cart-shipping__swatch-only');
  if ($notice.length === 0) return;
  const bookHandles = new Set(
    ($notice.first().attr('data-swatch-handles') || '').split(/\s+/).filter(Boolean)
  );
  const items = (cart && cart.items) || [];
  const swatchOnly =
    items.length > 0 && items.every(item => isSwatchProductLineItem(item, bookHandles));
  $notice.toggleClass('active', swatchOnly);
}

function swatchCartChange() {
  $(`.modelSection .item`).removeClass('active');
  $('.swatchList .item:not([sold_out]) .itemBox__select').removeAttr('loading').prop('disabled', false);
  $('.swatchList .item .itemBox__select').attr('aria-pressed', 'false').each(function () {
    $(this).attr('aria-label', $(this).attr('data-label-add'));
  });
  $(`.modelSection .popupList .popup .popupBox`).removeClass('active');
  // ⚠ sold_out 挂在 .btn 自己身上（snippets/products-grid-swatch.liquid 里
  // `<button class="btn btn--black" sold_out disabled>`），**不在 .popupBox 上**。
  // 写成 .popupBox:not([sold_out]) 的话 :not() 永远成立，等于没有守卫，
  // 售罄按钮的 disabled 会被摘掉 —— 鼠标有 .btn[sold_out] 的 pointer-events:none 兜着，
  // 但按钮会变成可 Tab 聚焦、被读屏播报为可用，按下去毫无反应。
  $('.popupList .popup .popupBox .productDetails .btn:not([sold_out])').removeAttr('loading').prop('disabled', false);
  const swatch = cartData.items.filter(isSwatchLineItem);
  // 文案从 .swatchCart 的 data-* 上读（snippets/swatch-cart.liquid 渲染）：
  // 刚好 10 片是允许的，不该说"超了、请删"。
  var $swatchCart = $('.swatchContainer .swatchCart');
  var atLimitText = $swatchCart.attr('data-at-limit-text') || 'You have reached the 10-swatch limit.';
  var overLimitText = $swatchCart.attr('data-over-limit-text') || 'Number of swatches exceeded. Please remove before checking out.';
  var num = 0, str = [];
  $.each(swatch, function (i, item) {
    num += item.quantity;
    // console.log(item);
    const $selectedItem = $(`.modelSection[data-id="${item.product_id}"] .item[data-color="${item.variant_title}" i]`);
    $selectedItem.addClass('active');
    $selectedItem.find('.itemBox__select').attr('aria-pressed', 'true').each(function () {
      $(this).attr('aria-label', $(this).attr('data-label-remove'));
    });
    $(`.modelSection[data-id="${item.product_id}"] .popupList .popup .popupBox[data-color="${item.variant_title}" i]`).addClass('active');
    str.push(`<button type="button" class="item" data-item-id="${item.id}">`);
    str.push(`<span class="visually-hidden">Remove swatch: </span>`);
    str.push(`<div class="itemBox">`);
    str.push(`<div class="imgBox">`);
    str.push(`<img loading="lazy" src="${imgUrlSize(item.image, 54)}" alt="" />`);
    str.push(`</div>`);
    str.push(`<div class="productTitle">`);
    str.push(`<div>`);
    str.push(`<span>${item.title.split(' ')[0]}</span>`);
    str.push(`<span>${item.variant_title}</span>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</button>`);
  });
  // .isFull 必须排在列表最前面，且文案要按 num 选
  str.unshift(`<div class="isFull">${num > 10 ? overLimitText : atLimitText}</div>`);

  $('.swatchContainer .swatchCart .cartNum')
    .html(`Selected Swatches (${num} / 10)`)
    .toggleClass('is-full', num >= 10);
  $('.swatchContainer .swatchCart .cartList').html(num > 0 ? str.join('') : `<div class="isEmpty">Please select your swatches</div>`);
  // .isFull 是上面 str 的第一个节点，CSS 里默认 display:none。
  // 重建列表之后要按当前数量重新决定它显不显示，否则加满的提示会被下一次
  // 购物车刷新冲掉，用户点第 11 片时只看到"没反应"。
  $('.swatchContainer .swatchCart .cartList .isFull').toggle(num >= 10);
  $('.swatchContainer .swatchCart .btn').css('display', num > 0 ? 'flex' : 'none');

  $('.quantity__input[aria-label*="Swatches"], .quantity__input[aria-label*="Swatches"]+button').attr('disabled', num >= 10);

  // $('.swatchContainer .swatchCart .cartList .item').on('click', function () {
  //   const id = $(this).attr('data-item-id');
  //   $(`#CartDrawer-CartItems .cart-item[data-item-id="${id}"] button`).click();
  //   // 获取元素
  //   const cartDrawer = document.querySelector('cart-drawer-items');

  //   // 安全调用检查
  //   if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
  //     cartDrawer.onCartDrawerUpdate();
  //   }

  //   setTimeout(() => {
  //     cartDataChange();
  //     swatchCartChange();
  //   }, 500);
  // })
}


function Product_swatchCartChange() {
  $('.popupList .popup .popupBox').removeClass('active');
  // ⚠ 这句是**全局**选择器，小样页和产品页的取样弹窗都会扫到。
  // 少了 :not([sold_out]) 的话，即使上面 swatchCartChange() 的守卫是对的，
  // 这里也会把小样页售罄按钮的 disabled 再摘一次，两条路径结果一样。
  //
  // ⚠ 而且这里**必须保持 removeAttr('disabled')，不能照抄成 .prop('disabled', false)**：
  // 产品页的取样弹窗按钮是 <div class="btn" ... disabled>（sections/main-product.liquid），
  // 两个分支都带 disabled、**就靠这一句摘掉才可用**；.prop() 对 <div> 只设 JS 属性、
  // 不动 HTML 属性，改过去那个按钮会永远禁用。
  $('.popupList .popup .popupBox .productDetails .btn:not([sold_out])').removeAttr('loading disabled');
  const swatch = cartData.items.filter(isSwatchLineItem);
  var num = 0;
  $.each(swatch, function (i, item) {
    num += item.quantity;

    var swatchItemBox = $(`.popupList .popup .popupBox[data-id="${item.variant_id}"][data-color="${item.variant_title.toLowerCase()}"]`);
    if (swatchItemBox.length > 0) {
      swatchItemBox.addClass('active');
    }
  });
}

// 同一时刻只认最后一次发出的 /cart.js。旧请求晚到会用删除前的购物车覆盖全局
// cartData，再拿它去比对已经换成新内容的 DOM —— 被删那件找不到商品行，
// 金额就会算错甚至变成 NaN。
// All callers share the same refresh and wait for the final authoritative snapshot.
function applyCartData(data) {
  cartData = data;
  try { trackCartLogs(data); } catch (error) { console.warn('Cart analytics unavailable:', error); }
  const valid = cartDataInit();
  if (typeof refreshSwatchCap === 'function') refreshSwatchCap();
  if (typeof refreshCheckoutButtons === 'function') refreshCheckoutButtons();
  if (!valid) throw new Error('Unable to calculate the cart display. Please reload your cart.');
}
async function cartDataChange() {
  try { await CartFlow.refresh(); return true; }
  catch (error) { console.error(error); CartFlow.error(error.message); return false; }
}

// 获取购物车总价
function subtotalChange() {
  setTimeout(() => {
    var subtotal = 0, totalPrice = matchNum($('.cart_Total .totalPrice').text().trim());
    $('.cart__checkout-button').attr('disabled', true);
    $('.drawer__inner-empty').css('display', cartData.item_count > 0 ? 'none' : 'flex');
    if (cartData.item_count > 0) {
      $('.drawer cart-drawer-items').removeClass('is-empty');
      $('.header__cart .cart-count-bubble').html(`<span aria-hidden="true">(${cartData.item_count})</span><span class="visually-hidden">${cartData.item_count} items</span>`);
      $('.cart__checkout-button').attr('disabled', false);
    }
    // $.each($('#CartDrawer .cart-item, #main-cart-items .cart-item'), function(i, item) {
    //   var priceText = $(item).find('.price:not(.price_sale)').eq(0).text().trim();
    //   if ($(item).find('.price_sale').length > 0) {
    //     priceText = $(item).find('.price_sale').eq(0).text().trim();
    //   }
    //   const price = matchNum(priceText);
    //   subtotal += price;
    // });
    // 获取元素
    const cartDrawer = document.querySelector('cart-drawer-items');

    // 安全调用检查
    if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
      cartDrawer.onCartDrawerUpdate();
    }
    $('.totals__subtotal-value, .subtotalPrice').html(`<span class="glc_money">${window.Shopify.currency.icon}${(cartData.original_total_price / 100).toFixed(2)}</span>`);
    // $('.totalPrice').html(`<span class="glc-money notranslate" translate="no">${window.Shopify.currency.icon}${(cartData.total_price / 100).toFixed(2)}</span>`);
    // console.log(subtotal);

    // 奖励阶梯（免运费 + 满减）—— 和 cartDataInit 走同一个函数，
    // 以前这里和上面各写了一份，一份硬编码英文串、一份用 data-message 模板，
    // 谁后跑谁赢，文案会打架。2026-10-09 合并。
    updateCartRewards(cartData, true);
    updateSwatchOnlyNotice(cartData);
  }, 1000);
}

function getSessionId() {
  let id = localStorage.getItem('track_session_id');
  if (!id) {
    if (crypto.randomUUID) {
      id = crypto.randomUUID(); // 或 generateUUID()
    } else {
      let str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      id = str.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    localStorage.setItem('track_session_id', id);
  }
  return id;
}

function trackCartLogs(cartData) {
  let isAdmin = localStorage.getItem('is_admin')
  let marketingCode = localStorage.getItem('mc')
  const data = {
    uuid: getSessionId(),
    is_admin: isAdmin,
    marketing_code: marketingCode,
    items: cartData.items,
    discount_codes: cartData.discount_codes,
  }
  if (window.location.hostname === '127.0.0.1') {
    navigator.sendBeacon('http://sitang.local.com/shopify/trackLogs/cart', JSON.stringify(data))
  } else {
    navigator.sendBeacon('https://app.thehues.com/shopify/trackLogs/cart', JSON.stringify(data))
  }
}

// Callers await the shared cart snapshot before restoring their controls.
async function addMultipleToCart(products) {
  const results = [];
  for (const productItem of products) {
    try {
      const response = await fetch(CartFlow.url('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: productItem.id,
          quantity: productItem.quantity,
        })
      });
      const data = await CartFlow.readMutation(response);
      // data.status 是 Shopify 出错时才有的字段（422 的响应体里带）
      if (!response.ok || data.status) {
        console.error('加购失败:', response.status, data);
        results.push({ status: 'error', httpStatus: response.status, data });
        continue;
      }
      results.push({ status: 'success', data });
    } catch (error) {
      console.error('Error adding product:', error);
      results.push({ status: 'error', error });
    }
  }
  const synced = await cartDataChange();
  if (synced === false) {
    console.error('购物车同步失败，cartData 可能是旧的，整页刷新');
    window.location.reload();
    throw new Error('Cart sync failed');
  }
  return results;
}

// 计算产品价格
function productPriceChange() {
  // 当前客户类型
  var currentCustomerType = customer.isB2B ? 'B2B' : 'C';

  var arr = [];
  var panel = parseInt($('input.quantity__input').val()) || 1;
  // Shopify 选项可由 BCPO 渲染成下拉、单选或隐藏输入；不能只读 :checked。
  const selectedOption = name => {
    const fields = $('#bcpo .selector-wrapper [name="' + name + '"]');
    const value = fields.filter(':checked').val() ?? fields.filter('select, input[type="hidden"]').val();
    return value == null || value === '' ? null : value;
  };
  var color = selectedOption('name0');
  var size = selectedOption('name1');
  var name2 = selectedOption('name2');
  var productItem = product.variants.filter((item) => {
    return item.option1 == color && item.option2 == size && item.option3 == name2;
  });
  const inputType = ['radio', 'checkbox'];
  $.each($('#bcpo .selector-wrapper:not([type="measurement"]) *[name*="properties"]'), function (i, item) {
    var type = false;
    var keys = $(item).attr('name') == 'name0' ? 'Color' : $(item).attr('name'), value = "", price = 0;
    if (!inputType.includes($(item).attr('type'))) {
      type = true;
      value = $(item).val();
      price = $(item).find('option').filter(function () { return this.value === String(value); }).attr('data-price');
    } else if (inputType.includes($(item).attr('type')) && $(item).prop("checked")) {
      type = true;
      value = $(item).val();
      price = $(item).attr('data-price');
    }
    price = parseFloat(price);
    if (type && !isNaN(price)) {
      arr.push({ "key": keys, "value": value, "price": price });
    }
  })

  var oldPrice = parseFloat(matchNum(product.sale_price) || 0);
  var newPrice = parseFloat(matchNum(product.regular_price) || 0);

  if (productItem.length > 0) {
    newPrice = parseFloat(productItem[0].price / 100 || 0);
    /*
     * 划线价必须跟着选中的变体一起换。
     *
     * oldPrice 的初值来自 product.sale_price，而那是
     * `product.compare_at_price | default: product.price`（main-product.liquid:137）——
     * **全部变体里最低的那个划线价**，不是当前变体的。只换 newPrice 不换 oldPrice，
     * 这两个数就不是一对了：变体 A $99/划线$129、变体 B $149/划线$199 的商品，
     * 选中 B 时会拿 129 去比 149，下面那条双向 toggleClass 判成"没打折"，
     * 把 Liquid 服务端渲染对了的 price--on-sale 当场抹掉。
     * （class 只加不减的年代这个不对称是无害的，改成双向切换后它就开始咬人了。）
     *
     * 变体没填 compare-at 时退回它自己的现价 —— 等价于"这个变体不打折"，
     * 而不是继承别的变体的划线价。
     */
    oldPrice = parseFloat((productItem[0].compare_at_price || productItem[0].price) / 100 || 0);
  }

  $.each(arr, function (i, item) {
    newPrice += parseFloat(item.price);
    oldPrice += parseFloat(item.price);
  });

  newPrice = newPrice * panel;
  oldPrice = oldPrice * panel;

  // 产品折扣
  var coupon = [], productCoupon = [], orderCoupon = [];
  $.each(product.collections, function (i, item) {
    const productCoupons = default_coupon_list.filter((defaultCoupon) => {
      const couponType = defaultCoupon.customer_type == 'All' || currentCustomerType == defaultCoupon.customer_type;
      return couponType && item.title == defaultCoupon.collection_title && defaultCoupon.coupon_type == 'Product Coupon' && newPrice >= defaultCoupon.doorsill;
    })
    if (productCoupons.length > 0) {
      // 获取符合条件的最大门槛
      // const maxValue = Math.max(...productCoupons.map(item => item.doorsill));
      // const result = productCoupons.filter(item => item.doorsill === maxValue);
      // productCoupon = result;
      productCoupon = productCoupons;
    }
  });

  // 订单折扣
  const orderCoupons = default_coupon_list.filter((defaultCoupon) => {
    const couponType = defaultCoupon.customer_type == 'All' || currentCustomerType == defaultCoupon.customer_type;
    return couponType && defaultCoupon.coupon_type == 'Order Coupon' && newPrice >= defaultCoupon.doorsill;
  });
  if (orderCoupons.length > 0) {
    // 获取符合条件的最大门槛
    // const maxValue = Math.max(...orderCoupons.map(item => item.doorsill));
    // const result = orderCoupons.filter(item => item.doorsill === maxValue);
    // orderCoupon = result;
    orderCoupon = orderCoupons;
  };

  coupon = productCoupon.length > 0 ? productCoupon : orderCoupon;
  if (productCoupon.length && orderCoupon.length && productCoupon[0].coupon_unit === orderCoupon[0].coupon_unit) {
    const savings = offer => offer.coupon_unit === '%'
      ? newPrice * Number(offer.coupon_value) / 100
      : Number(offer.coupon_value) * (offer.coupon_type === 'Order Coupon' ? 1 : panel);
    if (savings(orderCoupon[0]) > savings(productCoupon[0])) coupon = orderCoupon;
  }
  // console.log(coupon);
  if (coupon.length > 0) {
    if (coupon[0].coupon_unit == '%') {
      const couponNum = (100 - coupon[0].coupon_value) / 100;
      oldPrice = newPrice;
      newPrice *= couponNum;
    } else if (coupon[0].coupon_unit == '$') {
      oldPrice = newPrice;
      newPrice -= Number(coupon[0].coupon_value) * (coupon[0].coupon_type === 'Order Coupon' ? 1 : panel);
    }
  }

  if (newPrice < 0) {
    newPrice = 0;
  }

  // 门槛券会随着尺寸/数量变化而生效或失效。不能只在命中券时加 class，
  // 否则顾客把配置降回门槛以下后仍会看到促销布局（甚至原价/现价相同）。
  // compare-at 折扣也走同一个最终价判断，因此这里统一同步状态。
  $('.price-wrapper .price--product').toggleClass('price--on-sale', oldPrice > newPrice);

  $('.price--on-sale .price-item--regular').html(`<s class="price-item price-item--regular"><span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${oldPrice.toFixed(2)}</span></s>`);
  $('.price__regular span.price-item').html(`<span class="price-item price-item--regular money" data-usd="${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newPrice.toFixed(2)}" data-amount="${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newPrice.toFixed(2)}"><span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newPrice.toFixed(2)}</span></span>`);
  $('.price--on-sale .price-item.price-item--sale').html(`<span class="price-item price-item--sale money" data-usd="${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newPrice.toFixed(2)}" data-amount="${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newPrice.toFixed(2)}"><span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${newPrice.toFixed(2)}</span></span>`);
  // GLC 需要同一层 glc-money 才会把基础币种换成访客货币；不能只把 $ 换成 €。
  const baseSymbol = window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon;
  $('#AddToCart .btn .price').html(`<span class="glc-money notranslate" translate="no">${baseSymbol}${product.regular_price == '' ? oldPrice.toFixed(2) : newPrice.toFixed(2)}</span>`);

  updateDiscountTag(oldPrice, newPrice, coupon[0]);
}

/**
 * 折扣标签（N% OFF / Save $38.50）跟着实时价格走。
 *
 * 为什么非要在 JS 里重算：百分比不随尺寸变，金额会。定制窗帘的最终价由 VO 的
 * 宽高加价算出来，Liquid 渲染时只知道起价，页面上选完尺寸/改完数量之后，
 * "Save $15.90" 就不再是真的了。这里拿的是上面刚算完的同三个值
 * （oldPrice = 划线价，newPrice = 现价，coupon = 这一轮真正选中的券），
 * 所以标签和价格永远同源。
 *
 * ⚠ 券必须由调用方传进来，不能读首屏 Liquid 写的 data-discount-percent：
 * productPriceChange() 会按实时价重新选券，而 B2B 的阶梯整单折扣
 * （doorsill 3000 / 10000）Liquid 那边根本不参与判定 —— price.liquid 只认
 * doorsill == 0。顾客把尺寸配到越过门槛时，价格已经按 20% 算了，
 * 标签若还读首屏的 15% 就是当场说谎。
 *
 * 判定规则必须和 snippets/discount-label.liquid 里那套逐条对齐 —— 阈值、
 * 强制开关、面向顾客的文案全部从标签自己的 data-* 上读，不在这里写死第二份。
 *
 * 一个反直觉的点：VO 的尺寸加价是同时加到 oldPrice 和 newPrice 两边的
 * （见上面那个 $.each），所以 compare-at 清仓货的省钱金额其实不随尺寸变，
 * 只随数量翻倍；真正随尺寸长大的是百分比折扣那批。
 */
function updateDiscountTag(oldPrice, newPrice, coupon) {
  const $tag = $('.price-wrapper [data-discount-tag]');
  if (!$tag.length) return;

  // display 置空而不是 jQuery 的 hide/show：.couponTag 是 display: contents，
  // 被 show() 换成 block 会把它变成 flex item，整行价格的间距就散了。
  const hide = () => $tag.css('display', 'none');

  const amount = oldPrice - newPrice;
  if (!(amount > 0) || !(oldPrice > 0)) return hide();

  // '$' 面值券（小样的 Free Swatches）历来不出标签，和 price.liquid 的
  // couponType < 0 是同一条。
  if (coupon && coupon.coupon_unit === '$') return hide();

  // 券折扣的百分比用券面值：活动说 15% 就得是 15，不能被浮点取整改成 14%。
  const pct = coupon && coupon.coupon_unit === '%'
    ? Number(coupon.coupon_value)
    : Math.round((amount / oldPrice) * 100);

  const override = ($tag.attr('data-discount-override') || 'auto').toLowerCase();
  const percentFloor = Number($tag.attr('data-percent-floor'));
  const priceFloor = Number($tag.attr('data-price-floor'));

  let mode;
  if (override === 'percent') mode = 'percent';
  else if (override === 'amount') mode = 'amount';
  else if (pct >= percentFloor) mode = 'percent';
  else if (oldPrice > priceFloor) mode = 'amount';
  else mode = 'percent';
  if (mode === 'percent' && pct < 1) mode = 'amount';

  // 文案模板是 Liquid 从 locale 里取好写在 data-* 上的（店里 de/es/fr/it 都开着），
  // 这里只填占位符。金额要包 .glc-money，否则切币种时这个数不跟着转。
  const money = `<span class="glc-money notranslate" translate="no">${window.Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.icon}${amount.toFixed(2)}</span>`;
  const tpl = mode === 'percent'
    ? ($tag.attr('data-text-percent') || '__N__% OFF')
    : ($tag.attr('data-text-save') || 'Save __AMOUNT__');
  const html = mode === 'percent'
    ? tpl.replace('__N__', pct)
    : tpl.replace('__AMOUNT__', money);

  $tag.find('.couponTag__label').html(html);
  $tag.css('display', '');
}

function btnTypeChange() {
  var btnType = false;
  $.each($('#MainContent #bcpo:not(.g-card) .selector-wrapper:not(:has([name="properties[ROOM INFO (Optional)]"]))'), function (i, item) {
    if ($(item).find('.bcpo-label .bcpo-value').text().trim().length == 0 && $(item).find('>.bcpo-label[style="display: none;"]').length == 0) {
      btnType = true;
    }
  });

  $('button[name="add to cart"]').attr('disabled', btnType);
}

// 默认根据id去重
function removeDuplicates(List, keys = "id") {
  const uniqueData = {};
  List.forEach((item) => {
    if (!uniqueData[item[keys]]) {
      uniqueData[item[keys]] = item;
    }
  });
  return Object.values(uniqueData);
}

var topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];
// 页面滚动使指定元素置顶
// gap：元素顶部与吸顶头部之间额外留的空隙
function windowScrollTop(event, topEventList = [], fevent = "html,body", gap = 0) {
  topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];
  if (topEventList.length == 0) {
    topEventList = topEvent;
  }
  var item = event,
    headerHeight = 0;
  const itemScrollTop = item.offset().top;
  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }
  const feventScrollTop = fevent == "html,body" ? 0 : $(fevent).scrollTop();
  $(fevent).animate(
    {
      scrollTop: Math.floor(
        itemScrollTop - headerHeight - $(fevent).offset().top + feventScrollTop - gap
      ),
    },
    150
  );
}

// PDP 加购校验：标记未填的选项行，并在标题下方给出一句提示。
// 提示显隐完全跟着 .emptyInput 走（CSS 控制），各处原有的 removeClass('emptyInput') 自动把提示收掉
const OPTION_ERROR_ICON = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.25" stroke="currentColor" stroke-width="1.5"/><path d="M8 4.5v4.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="8" cy="11.25" r="0.9" fill="currentColor"/></svg>';

function optionErrorText(item) {
  const $item = $(item);
  // 标题形如 "LINING:" / "SELECT COLOR:" / "Single Panel Width:"
  let name = ($item.find('.bcpo-title').first().text() || '')
    .replace(/[:：]\s*$/, '')
    .replace(/^\s*(please\s+)?(select|choose)\s+/i, '')
    .trim();
  if (name && name === name.toUpperCase()) {
    name = name.toLowerCase().replace(/\b[a-z]/g, c => c.toUpperCase());
  }
  // 只有手填框（尺寸 Custom、文本）才说 enter；有可点选项的都说 select。
  // .has-input 里的是 inputRange() 自绘的输入框/分数下拉，自带隐藏 radio，不算可点选项
  const hasChoices = $item.find('input[type="radio"], input[type="checkbox"], select:visible, .hasItem > .item:not(.has-input)')
    .filter(function () { return $(this).closest('.has-input').length == 0; }).length > 0;
  const typed = !hasChoices && $item.find('.selectInput, input[type="number"], input[type="text"], textarea').length > 0;
  if (!name) return typed ? 'Please fill in this field' : 'Please make a selection';
  return `Please ${typed ? 'enter' : 'select'} ${name}`;
}

// message：具体的不合法原因（如超出范围）；不传则用通用的 "Please select/enter X"。
// data-option-error 标记"这一行由校验标记过"，price.js 靠它复查、有效了才撤提示
function markOptionEmpty(item, message = '') {
  $(item).each(function () {
    const $item = $(this);
    let $msg = $item.children('.option-error');
    if ($msg.length == 0) {
      $msg = $(`<p class="option-error" role="alert">${OPTION_ERROR_ICON}<span></span></p>`);
      const $label = $item.children('.bcpo-label');
      $label.length > 0 ? $label.after($msg) : $item.prepend($msg);
    }
    $msg.children('span').text(message || optionErrorText(this));
    $item.addClass('emptyInput').attr('data-option-error', '');
  });
}

// 滚到视觉上最靠上的未填选项。selector-wrapper 被 CSS order 重排过，
// DOM 顺序 ≠ 视觉顺序，不能直接拿 jQuery 集合的第一个。已经在可视区内就不滚，免得页面乱跳
function scrollToEmptyOption($items) {
  const topList = ["header.header", '.productInfoTitle'];
  const gap = 24;
  let target = null, targetTop = Infinity;
  $items.each(function () {
    const rect = this.getBoundingClientRect();
    if (rect.height > 0 && rect.top < targetTop) {
      targetTop = rect.top;
      target = this;
    }
  });
  if (!target) return null;
  const headerHeight = topList.reduce((sum, selector) => sum + (parseInt($(selector).outerHeight()) || 0), 0);
  const rect = target.getBoundingClientRect();
  // 提示就在标题下面，标题 + 提示 + 第一排选项露出来就算看得到
  if (!(rect.top >= headerHeight && rect.top + Math.min(rect.height, 120) <= window.innerHeight)) {
    windowScrollTop($(target), topList, "html,body", gap);
  }
  // 返回选中的那一行，调用方据此决定焦点落在哪
  return target;
}

// 页面滚动使指定元素居中
function windowScrollToMiddle(
  event,
  topEventList = topEvent,
  fevent = "html,body",
  position = "top"
) {
  var $target = event;
  var headerHeight = 0;
  topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];

  if (topEventList.length == 0) {
    topEventList = topEvent;
  }

  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }

  var viewportHeight = $(window).height();
  var targetHeight = $target.outerHeight();
  var targetPosition = $target.offset().top - headerHeight;
  var scrollToPosition = "";

  switch (position) {
    case 'top':
      // 指定元素顶部居中
      scrollToPosition = targetPosition - viewportHeight / 2;
      break;
    case 'center':
      // 指定元素中心点居中
      scrollToPosition = targetPosition - (viewportHeight - targetHeight) / 2;
      break;
    default:
      break;
  }

  $(fevent).animate(
    {
      scrollTop: scrollToPosition,
    },
    150
  );
}

function windowScrollHeight() {
  return matchNum(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
}

// 判断元素是否完整在可视窗口内
// element: 元素类名; top:元素于顶部的距离
function isElementInViewport(element, top = 0) {
  var rect = element.getBoundingClientRect();
  return (
    rect.top >= top &&
    rect.left >= 0 &&
    rect.bottom <=
    (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// 防抖函数
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

// 节流函数
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this,
      args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

// 获取指定元素在视窗的位置
function elementCenter(ele) {
  var elementOffset = $(ele).offset(); // 获取元素相对于文档的偏移
  var elementWidth = $(ele).outerWidth();
  var elementHeight = $(ele).outerHeight();

  // 计算元素中心相对于视窗的位置
  var centerX = elementOffset.left + elementWidth / 2 - $(window).scrollLeft();
  var centerY = elementOffset.top + elementHeight / 2 - $(window).scrollTop();

  return {
    top: centerY,
    left: centerX,
  };
}

function preventScroll(event) {
  event.preventDefault();
}

// 将产品名称转换为handle格式
function convertToHandle(name) {
  return name.toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')  // 替换特殊字符为-
    .replace(/-+/g, '-')          // 合并连续-
    .replace(/^-+|-+$/g, '');     // 去除首尾-
}

// 从 URL 提取文件名
function extractFileNameFromUrl(url) {
  if (url == undefined) {
    return '';
  }
  // 确保 URL 是有效的，可以添加一个协议
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https:' + url;
  }
  // 使用 URL 对象解析 URL
  const urlObj = new URL(url);
  // 获取路径名
  const pathName = urlObj.pathname;
  // 使用 split 方法从路径名中提取文件名
  const fileName = pathName.split('/').pop();
  return fileName;
}

// 缓存管理器（使用localStorage）
const productCache = {
  get: async (handle) => {
    const cache = localStorage.getItem(`product_${handle}`);
    if (!cache) return null;

    const { data, expires } = JSON.parse(cache);
    if (Date.now() < expires) return data;

    localStorage.removeItem(`product_${handle}`);
    return null;
  },
  set: (handle, data, ttl = 3600000) => { // 缓存1小时
    const expires = Date.now() + ttl;
    localStorage.setItem(`product_${handle}`, JSON.stringify({
      data,
      expires
    }));
  },
  clearAll: () => {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('product_')) {
        localStorage.removeItem(key);
      }
    });
  }
};

// 获取函数（带缓存）
async function getProduct(productName) {
  try {
    var response = [];
    if (window.Shopify.country == "GB") {
      productName += '-gb';
    }
    const productHandle = convertToHandle(productName);

    // 先检查缓存
    const cachedData = await productCache.get(productHandle);
    if (cachedData) return cachedData;

    // 没有缓存则发起请求
    response = await $.ajax({
      url: `/products/${productHandle}.js`,
      dataType: 'json'
    });

    // 缓存新数据
    const productData = {
      ...response,
      handle: productHandle
    };

    productCache.set(productHandle, productData);
    return productData;
  } catch (error) {
    console.error(`${productName} error:`, error.statusText);
    return null;
  }
}

// 带自动重试的获取函数
async function getProductWithRetry(productName, retries = 3) {
  for (let i = 0; i < retries; i++) {
    try {
      const product = await getProduct(productName);
      if (product) return product;
      await new Promise(res => setTimeout(res, 1000 * (i + 1)));
    } catch (error) {
      console.warn(`${i + 1} failed, Ready to try again...`);
    }
  }
  return null;
}

// 批量获取函数（带并发控制）
async function fetchMultipleProducts(productNames, concurrent = 3) {
  const results = [];
  const queue = [...productNames];

  async function worker() {
    while (queue.length > 0) {
      const name = queue.shift();
      const product = await getProductWithRetry(name);
      if (product) {
        results.push({ ...product });
      }
    }
  }

  // 创建并发工作线程
  const workers = Array.from({ length: concurrent }, () => worker());
  await Promise.all(workers);

  return results;
}

// 获取下拉列表的最小值和最大值
function SelectRange(event) {
  const $event = $(event);
  if ($event.find('option:first-of-type').val() == '') {
    $event.find('option:first-of-type').text('Input Size');
  }
  const minEvent = $event.find('option:not([disabled])').filter((j, optionItem) => {
    return $(optionItem).css('display') != 'none';
  })[0];

  let currentMin = '', currentMax = '';
  const minVal = minEvent ? $(minEvent).val() : '';
  if (minVal) {
    currentMin = minVal.split('"')[0];
  }
  const maxVal = $event.find('option:last-of-type').val();
  if (maxVal) {
    currentMax = maxVal.split('"')[0];
  }

  return {
    "min": currentMin,
    "max": currentMax
  };
}

// 转换日期格式
function currentFormatDate(inputDate = new Date()) {
  const parseDate = (input) => {
    const formats = [
      /^(\d{4})[/-](\d{2})[/-](\d{2})$/,  // YYYY/MM/DD 或 YYYY-MM-DD
      /^(\d{2})[/-](\d{2})[/-](\d{4})$/   // MM/DD/YYYY 或 MM-DD-YYYY
    ];

    for (const regex of formats) {
      const match = input.match(regex);
      if (match) {
        const [_, year, month, day] = match;
        // 统一为YYYY-MM-DD格式创建Date对象
        const date = new Date(`${year}-${month}-${day}`);
        // 验证日期有效性
        if (!isNaN(date)) return date;
      }
    }
    throw new Error('Invalid date format. Use "YYYY/MM/DD", "mm/dd/yyyy", or Date object.');
  };

  // 处理输入
  const date = typeof inputDate === 'string'
    ? parseDate(inputDate)
    : inputDate;

  // 验证日期有效性
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error('Invalid date object');
  }

  // 月份映射表（首字母大写）
  const months = {
    0: 'Jan', 1: 'Feb', 2: 'Mar', 3: 'Apr',
    4: 'May', 5: 'Jun', 6: 'Jul', 7: 'Aug',
    8: 'Sep', 9: 'Oct', 10: 'Nov', 11: 'Dec'
  };

  // 格式化输出
  return `${months[date.getMonth()]} ${String(date.getDate()).padStart(2, '0')}, ${date.getFullYear()}`;
}

function extractDate(input) {
  return input.split(' ')[0];
}

// 补零展示，1 => 01
function padNumber(num) {
  return num.toString().padStart(2, '0');
}

// 返回带尺寸的图片链接
function imgUrlSize(url, size = '') {
  if (url == undefined) {
    return url;
  }

  if (size != '') {
    return url.includes('?') ? `${url}&width=${size}` : `${url}?width=${size}`;
  } else {
    return url;
  }
}

// FAQ模块展开/隐藏下拉列表
function initCollapsiblePanel({
  containerSelector,   // 外层容器选择器（原.faqList）
  itemSelector,         // 单个面板项选择器（原.faqItem）
  triggerSelector,      // 触发元素选择器（原.faqTitle）
  contentSelector       // 内容元素选择器（原.faqTitle + div）
}) {
  $(document).on('click', `${containerSelector} ${triggerSelector}`, function () {
    const $trigger = $(this);
    const $item = $trigger.closest(itemSelector);

    if ($item.hasClass('active')) {
      // 关闭当前面板
      $item.find(contentSelector).slideUp(150, () => {
        $item.removeClass('active');
      });
    } else {
      // 展开当前面板
      $item.find(contentSelector).slideDown(150, () => {
        // 关闭其他所有面板
        const $activeItems = $(containerSelector).find(itemSelector).filter('.active');
        $activeItems.find(contentSelector).slideUp(150);
        $activeItems.removeClass('active');

        // 激活当前面板
        $item.addClass('active');
      });
    }
  });
}

// 0.5小数转1/2分数
function decimalToFraction(num) {
  const tolerance = 1e-6; // 容差值，处理浮点精度问题
  const h = Math.floor(num); // 整数部分
  num = num - h; // 仅处理小数部分

  if (Math.abs(num) < tolerance) {
    return h ? `${h}/1` : "0/1"; // 整数直接返回
  }

  let denominator = 1;
  while (Math.abs(num * denominator - Math.round(num * denominator)) > tolerance) {
    denominator *= 10;
  }

  let numerator = Math.round(num * denominator); // 初始分子
  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b)); // 最大公约数计算
  const divisor = gcd(numerator, denominator); // 约分

  numerator = Math.abs(numerator) / divisor;
  denominator = Math.abs(denominator) / divisor;

  return `${h ? h + ' ' : ''}${numerator}/${denominator}`;
}

// 1/2分数转0.5小数
function fractionToDecimal(text) {
  if (text.includes('/')) {
    const textNum = text.split('"')[0];
    const [numerator, denominator] = textNum.split('/').map(Number);
    return numerator / denominator;
  } else {
    return matchNum(text);
  }
}

// 小数最接近分数下拉框中的值
function findClosestFraction(x) {
  const fractions = [
    { value: 0, fraction: '0' },
    { value: 0.125, fraction: '1/8' },
    { value: 0.25, fraction: '1/4' },
    { value: 0.375, fraction: '3/8' },
    { value: 0.5, fraction: '1/2' },
    { value: 0.625, fraction: '5/8' },
    { value: 0.75, fraction: '3/4' },
    { value: 0.875, fraction: '7/8' }
  ];

  let closest = fractions[0];
  let minDiff = Math.abs(x - fractions[0].value);

  for (let i = 1; i < fractions.length; i++) {
    const diff = Math.abs(x - fractions[i].value);
    if (diff < minDiff) {
      minDiff = diff;
      closest = fractions[i];
    }
  }

  return closest.fraction;
}

// 提取订单含有 % 的discount
function matchDiscount(str = '') {
  const s = str.toString();
  // 匹配数字+百分号
  const percentMatch = s.match(/(\d+\.?\d*|\.\d+)\s*%/);
  if (percentMatch) {
    return parseFloat(percentMatch[1]) || 0;
  }
  // 没有%返回null，不存入数组
  return null;
}
